<template>
<div class="content-wrap">
    <div class="register-wrap">
      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="영업기회ID">
              <template #end="slotProps">
                <ElInput :id="slotProps.id" v-model="state.salesOptyParams.sales_id" disabled placeholder="자동생성" />
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="End User" required>
              <template #end="slotProps">
                <div class="input-group">
                  <ElInput :id="slotProps.id" ref="endCmpNmRef" v-model="state.salesOptyParams.end_user_cmp_nm"  @click="openCmpModal({key : 'end_user_cmp',target :'sales'})" readonly />
                  <ElButton type="s-search" ref="endCmpNmBtnRef" @click="openCmpModal({key : 'end_user_cmp',target :'sales'})"></ElButton>
                </div>
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="매출처" required>
              <template #end="slotProps">
                <div class="input-group">
                  <ElInput :id="slotProps.id" v-model="state.salesOptyParams.sales_cmp_nm" ref="salesCmpNmRef" @click="openCmpModal({key : 'sales_cmp',target :'sales'})" readonly />
                  <ElButton type="s-search" @click="openCmpModal({key : 'sales_cmp',target :'sales'})"></ElButton>
                </div>
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3" @click="openMngModal('manager1')">
            <ElLabel name="담당자1" required>
              <template #end="{id}">
                  <ElInput :id="id" v-model="state.salesOptyParams.manager1" ref="manager1Ref" :maxlength="10"/>
              </template>
            </ElLabel>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <ElLabel name="영업기회명" required>
              <template #end="{id}">
                  <ElInput :id="id" v-model="state.salesOptyParams.sales_nm" ref="salesNmRef" :maxlength="100"/>
              </template>
            </ElLabel>
          </div>
        </div>
        
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="영업대표" required>
              <template #end="{id}">
                  <ElInput :id="id" v-model="state.salesOptyParams.sales_ceo" ref="salesCeoRef" readonly/>
              </template>
            </ElLabel>
          </div>
        </div>  
        <div class="col-md-3">
          <div class="mb-3" @click="openMngModal('manager2')">
            <ElLabel name="담당자2">
              <template #end="{id}">
                  <ElInput :id="id" v-model="state.salesOptyParams.manager2" ref="manager2Ref" :maxlength="10"/>
              </template>
            </ElLabel>
          </div>
        </div>            
      </div>


      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="Bridge(B),Risk(R)">
              <template #end>
                <SelectCode
                ref="BRSelectRef"
                :cd_gr="'BNR_CD'"
                :matchCd="state.salesOptyParams.bnr_cd"
                :hyphenIS="true"
                @return="r=>state.salesOptyParams.bnr_cd = r.cd_id"
              />
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="Stage" required>
              <template #end>
                <SelectCode
                ref="stgSelectRef"
                :cd_gr="'STG_CD'"
                :matchCd="state.salesOptyParams.stage_cd"
                @return="r=>state.salesOptyParams.stage_cd = r.cd_id"
              />
              </template>
            </ElLabel>
          </div>
        </div>      
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="우선협상자 선정일(Won Date)" required>
              <template #end>
                <DatePicker
                  ref = "wonDateRef"
                  :selectDate="state.salesOptyParams.won_dt"
                  :max-date="state.salesOptyParams.po_dt"
                  @return="r=>state.salesOptyParams.won_dt = r"
                  />
              </template>
            </ElLabel>
          </div>
        </div>

        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="PO발행일" required>
              <template #end>
                <DatePicker
                  ref="poDateRef"
                  :selectDate="state.salesOptyParams.po_dt"
                  :min-date="state.salesOptyParams.won_dt"
                  @return="r=>state.salesOptyParams.po_dt = r"
                  />
              </template>
            </ElLabel>
          </div>
        </div>        
      </div>

      
      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="매출세금계산서 발행일" required>
              <template #end>
                <DatePicker
                  :selectDate="state.inoutParams.tax_dt"
                  @return="r=>state.inoutParams.tax_dt = r"
                />
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="발행여부" required>
              <template #end>
                <SelectCode
                    ref="taxYnRef"
                    :cd_gr="'YN_CD'"
                    :matchCd="state.inoutParams.tax_yn"
                    @return="r=>state.inoutParams.tax_yn= r.cd_id"
                  />
              </template>
            </ElLabel>
          </div>
        </div>      
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="수금일" required>
              <template #end>
                <DatePicker
                  :selectDate="state.inoutParams.collect_dt"
                  @return="r=>state.inoutParams.collect_dt = r"
                />
              </template>
            </ElLabel>
          </div>
        </div>

        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="수금여부" required>
              <template #end>
                <SelectCode
                    ref="collectYnRef"
                    :cd_gr="'YN_CD'"
                    :matchCd="state.inoutParams.collect_yn"
                    @return="r=>state.inoutParams.collect_yn= r.cd_id"
                  />
              </template>
            </ElLabel>
          </div>
        </div>        
      </div>

      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="최초 등록일">
              <template #end>
                <DatePicker
                  :selectDate="state.salesOptyParams.reg_dt"
                  @return="r=>state.salesOptyParams.reg_dt = r"
                />
              </template>
            </ElLabel>


          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="고객PO#">
              <template #end="{id}">
                <ElInput :id="id" classNm="form-control me-1" v-model="state.salesOptyParams.custom_po" onlyNumber :maxlength="19"/>
              </template>
            </ElLabel>

          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="상품(납품)정보">
              <template #end="{id}">
                <ElInput :id="id" v-model="state.salesOptyParams.prd_info" :maxlength="20"/>
              </template>
            </ElLabel>

          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="납품완료일">
              <template #end="{id}">
                <DatePicker
                  :selectDate="state.salesOptyParams.dlv_dt"
                  @return="r=>state.salesOptyParams.dlv_dt = r"
                />
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="PSP 지정여부">
              <template #end="{id}">
                <SelectCode
              :cd_gr="'YN_CD'"
              :matchCd="state.salesOptyParams.psp_yn"
              @return="r=>state.salesOptyParams.psp_yn = r.cd_id"
            />
              </template>
            </ElLabel>

          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="검수완료일">
              <template #end="{id}">
                <DatePicker
                  :selectDate="state.salesOptyParams.isp_dt"
                  :monthMinMaxDate="monthMinMaxDate"
                  @return="r=>state.salesOptyParams.isp_dt = r"
                />
              </template>
            </ElLabel>

          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <div class="form-check form-check-inline">
              <ElLabel name="갱신계약 영업기회 매핑">
                <template #start="{ id }">
                  <ElCheckbox :id="id" v-model="state.warMapping" @checkboxChange="openOptyModal()" />
                  <ElCheckbox 
                    ref='optyModalBtn' 
                    data-bs-toggle="modal" 
                    data-bs-target="#optyModal" 
                    v-show="false"
                  />
                </template>
              </ElLabel>
            </div>
            <ElInput ref="wSalesIdRef" v-model="state.salesOptyParams.w_sales_id" @inputClick="openOptyModal" readonly/>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <div class="form-check form-check-inline">
              <ElLabel name="계약만료일">
                <template #start="{ id }">
                  <ElCheckbox 
                    :id="id" 
                    v-model="state.salesOptyParams.w_end_ck" 
                  />
                </template>
              </ElLabel>
            </div>
            <DatePicker
            :selectDate="state.salesOptyParams.w_end_dt"
            :textable="true"
            :monthMinMaxDate="monthMinMaxDate"
            @return="r=>state.salesOptyParams.w_end_dt = r"
            />
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <!--  활성화 클래스 btn-active -->
            <ElLabel name="즐겨찾기">
              <template #end="{ id }">
                <ElButton 
                  :id="id"
                  type="bookmarkL"
                  :active="state.salesOptyParams.bkmark_yn === 'Y'"
                  @buttonClick="changeBkmark()"
                >
                  즐겨찾기 추가
                </ElButton> 
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="Aging(Days)">
              <template #end="{ id }">
                <ElInput :id="id" v-model="aginng" readonly/>
              </template>
            </ElLabel>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="총 매출금액" required>
              <template #end="{id}">
                  <ElInput
                    :id="id"
                    :modelValue="priceToString(outcome_sum)"
                    @update:modelValue="r=>outcome_sum = r"
                    readonly
                  />
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="총 매입금액" required>
              <template #end="{id}">
                  <ElInput
                    :id="id"
                    :modelValue="priceToString(income_sum)"
                    @update:modelValue="r=>income_sum = r"
                    readonly
                  />
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="GM Amount" required>
              <template #end="{id}">
                  <ElInput
                    :id="id"
                    :modelValue="priceToString(gm_amt)"
                    @update:modelValue="r=>gm_amt = r"
                    readonly
                  />
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="GM%" required>
              <template #end="{id}">
                  <ElInput
                    :id="id"
                    :modelValue="priceToString(gm_amt_per)"
                    @update:modelValue="r=>gm_amt_per = r"
                    readonly
                  />
              </template>
            </ElLabel>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="mb-1">
            <ElLabel name="메모">
              <template #end="{id}">
                <ElInput :id="id" v-model="state.salesOptyParams.memo"/>
              </template>
            </ElLabel>
          </div>
        </div>
      </div>
      <div class="row">
          <Caption
            ref="captionRef"
            :tbId="state.captionTbId"
            :cap_seq="state.salesOptyParams.opty_seq"></Caption>
      </div>
    </div><!-- //register-wrap -->

    <div class="text-end py-3">
      <ElButton type="primary" @buttonClick="downTemplateOpty()">영업기회 템플릿</ElButton>
      <ElButton type="primary" @buttonClick="selectTemplateUploadFile()">일괄등록</ElButton>
      <ElButton type="primary" @buttonClick="router.push('/sr/MSR_SO_002')">이전</ElButton>
      <ElButton type="primary" @buttonClick="checkValidation('Y')">임시저장</ElButton>
      <ElButton type="primary" @buttonClick="moveToPage('/mp/MMP_AM_001','임시저장함으로 이동하시겠습니까?')">임시저장함</ElButton>
      <ElButton type="primary"  @buttonClick="checkValidation('N')">등록완료</ElButton>
    </div>

    <div class="accordion" id="accordionPanelsStayOpenExample">
      <div class="accordion-item">
        <h2 class="accordion-header">
          <ElButton 
            type="accordionHeader" 
            target="panelsStayOpen-collapseOne"
          >
            매입처/상품 정보
          </ElButton>
        </h2>
        <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse">
          <div class="accordion-body accordion-body-register">
            
            <div class="search-wrap">
              <div class="row">
                <div class="col-md-3">
                  <div class="mb-3">
                    <ElLabel name="매입처">
                      <template #end="{ id }">
                        <ElInput :id="id" v-model="state.searchParam.buy_cmp_info_nm" @inputKeyupEnter="searchInoutList()"/>
                      </template>
                    </ElLabel>
                    
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <ElLabel name="상품">
                      <template #end="{ id }">
                        <ElInput :id="id" v-model="state.searchParam.goods_nm" @inputKeyupEnter="searchInoutList()"/>
                      </template>
                    </ElLabel>

                  </div>
                </div>                      
              </div>
            </div>
            <div class="search-detail-wrap"></div>
  
            <div class="text-end py-2">
              <ElButton type="search" @buttonClick="searchInoutList()">검색</ElButton>
            </div>
  
            <div class="d-flex justify-content-between">
              <div></div>
              <div class="table-btn-group d-flex align-items-center">
                <ElButton type="excelDownload" @buttonClick="inoutExcelDown()">엑셀다운</ElButton>
              </div>
            </div>

            <div class="table-list">
              <DataTable
                :value="state.searchInoutList"
                paginator
                :rows="10"
                :rowsPerPageOptions="[10, 20, 50, 100, 200]"
                editMode="cell"
                @cell-edit-complete="onCellEditComplete"
                scrollable
                :pt="{
                  wrapper : {style:'height : 600px'},
                  column: {
                      bodycell: ({ state }) => ({
                          class: [{ 'pt-0 pb-0': state['d_editing'] }]
                      })
                  }
                }"
                  >
                  <template #empty>
                          <div>데이터가 존재하지 않습니다.</div>
                  </template>
                  <Column>
                    <template #header>
                      <ElCheckbox v-model="allCheck"/>
                    </template>
                    <template #body="{ data }">
                        <ElCheckbox 
                        v-model="state.inoutSelectedRow" 
                        :value="data"
                        />
                    </template>
                  </Column>
      <template v-for="inout of state.inoutGridColumn" :key="inout.field">
      <Column
        v-if="inout.visible"
        :field="inout.field"
        :header="inout.header"
        :style="inout.style"
        :sortable="inout.sortable"
      >
        <template #body="{ data, field }">
          <div
            v-if="field.includes('class_nm')"
            class="class-nm"
            @click="openProdModal({ key: field, target: 'inout', index: data.index })"
          >
            {{ data[field] }}
          </div>
          <div
            v-else-if="field == 'made_cmp_info_nm'"
            class="cmp-nm"
            @click="openCmpModal({ key: 'made', target: 'inout', index: data.index })"
          >
            {{ data[field] }}
          </div>
          <div
            v-else-if="field == 'buy_cmp_info_nm'"
            class="cmp-nm"
            @click="openCmpModal({ key: 'buy', target: 'inout', index: data.index })"
          >
            {{ data[field] }}
          </div>
          <div v-else-if="field == 'gm_amt'">
            {{ priceToString(data[field]) }}
          </div>
          <div v-else-if="field == 'gm_amt_per'">
            {{ data[field] }}
          </div>
          <div v-else-if="field.includes('sum')">
            <span> {{ numberFomat(data[field]) }} </span>
          </div>
          <div v-else-if="field ==='gpu_model_qty' && checkGPUModel(state.inoutRowData[data.index].prod_class_id) == true">
            <span> {{ numberFomat(data[field]) }} </span>
          </div>
           <div v-else-if="field ==='gpu_model_nm' && checkGPUModel(state.inoutRowData[data.index].prod_class_id) == true">
            <span> {{ getCodeNm(data[field]) }} </span>
          </div>
          <div v-else-if="field ==='gpu_model_nm' && 
            checkGPUModel(state.inoutRowData[data.index].prod_class_id) == false"
          >
            <span> - </span>
          </div>
          <div v-else-if="field ==='gpu_model_qty' && 
            checkGPUModel(state.inoutRowData[data.index].prod_class_id) == false"
          >
            <span> - </span>
          </div>
          <div v-else>
            <span>{{ data[field] }}</span>
          </div>
        </template>

        <template #editor="{ data, field }">
          <SelectCode
            v-if="
              field == 'ins_yn' ||
              field == 'tax_sale_yn' ||
              field == 'purchase_yn' ||
              field == 'pay_yn' ||
              field == 'collect_yn' ||
              field == 'tax_yn'
            "
            :cd_gr="'YN_CD'"
            :matchCd="data[field]"
            :focus="true"
            @return="(r) => (data[field] = r.cd_id)"
          />
          <SelectCode
            v-else-if="field == 'gpu_model_nm' && checkGPUModel(state.inoutRowData[data.index].prod_class_id)"
            :cd_gr="'GPU_MODEL_CD'"
            :matchCd="data[field]"
            :focus="true"
            :chk_ess="'Y'"
            :isShow="checkGPUModel(state.inoutRowData[data.index].prod_class_id)"
            @return="(r) => (data[field] = r.cd_id)"
          />
          <div
            v-else-if="field.includes('class_nm')"
            class="class-nm"
            @click="openProdModal({ key: field, target: 'inout', index: data.index })"
          >
            <span>{{ data[field] }}</span>
          </div>
          <div
            v-else-if="field == 'made_cmp_info_nm'"
            class="cmp-nm"
            @click="openCmpModal({ key: 'made', target: 'inout', index: data.index })"
          >
            {{ data[field] }}
          </div>
          <div
            v-else-if="field == 'buy_cmp_info_nm'"
            class="cmp-nm"
            @click="openCmpModal({ key: 'buy', target: 'inout', index: data.index })"
          >
            {{ data[field] }}
          </div>
          <div v-else-if="field === 'tax_sale_dt'" style="width: 200px">
            <DatePicker
              :selectDate="data[field]"
              @return="(r) => (data[field] = r)"
            />
          </div>
          <div v-else-if="field === 'pay_dt'" style="width: 200px">
            <DatePicker
              :selectDate="data[field]"
              @return="(r) => (data[field] = r)"
            />
          </div>
          <div v-else-if="field.includes('dt')" style="width: 200px">
            <DatePicker
              :selectDate="data[field]"
              @return="(r) => (data[field] = r)"
            />
          </div>
          <div v-else-if="field ==='gpu_model_nm' && 
            checkGPUModel(state.inoutRowData[data.index].prod_class_id) == false"
          >
            <span> - </span>
          </div>
          <div v-else-if="field ==='gpu_model_qty' && 
            checkGPUModel(state.inoutRowData[data.index].prod_class_id) == false"
          >
            <span> - </span>
          </div>
          <ElInput
            v-else
            v-model="data[field]"
            onlynumber
            onlyPlusNumber
            :maxlength="17"
          />
        </template>
      </Column>
    </template>
                
              </DataTable>
            </div> 
            
            <div class="text-end py-3">
            <!-- 2025-03-27 
              <ElButton type="primary" @buttonClick="downTemplateInout()">매입매출 템플릿 다운로드</ElButton>
              <ElButton type="primary" @buttonClick="downloadCmpExcel()">회사 엑셀 다운로드</ElButton>
              <ElButton type="primary" @buttonClick="downloadProdExcel()">상품분류 엑셀 다운로드</ElButton>
              <ElButton type="primary" @buttonClick="selectUploadFile()">일괄등록</ElButton>-->
              <ElButton type="primary" @buttonClick="addInoutData()">추가</ElButton>
              <ElButton type="primary" @buttonClick="deleteInoutData()">삭제</ElButton>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="accordion" id="accordionPanelsStayOpenExample">
      <div class="accordion-item">
        <h2 class="accordion-header">
          <ElButton type="accordionHeader" target="panelsStayOpen-collapseTwo" :active="state.resFileList.length > 0">
            첨부파일
          </ElButton>
        </h2>
        <div id="panelsStayOpen-collapseTwo" :class="[state.resFileList.length > 0 ?'accordion-collapse' : 'accordion-collapse collapse']">
          <div class="accordion-body accordion-body-register">
            <FileUpload
              ref="fileUploadRef"
              @return="res => getFileList(res)"
              @deleteData="res => getDeleteFile(res)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
    
    
    <!--상품 modal-->
    <ProdClassModal ref="prodClassModalRef" @return="r=>updateParam('prod',r)" :fs_year = "state.fs_year"/>
    <!-- company modal -->
    <CompanyModal ref="companyModalRef" @return="r=>updateParam('company',r)"/>

    <!--warranty sales modal-->
    <WarrantySalesModal ref="warrantySalesModalRef" @return="r=>updateParam('opty',r)"/>
  <ElButton 
  ref="cmpModalBtnRef"
  data-bs-toggle="modal" 
  data-bs-target="#cmpModal" 
  v-show="false"/>

  <ElButton 
  ref="prodModalBtnRef"
  data-bs-toggle="modal" 
  data-bs-target="#prodModal" 
  v-show="false"/>
  
  <ExcelTemplateManage
      v-show="false"
      ref="excelTempManageRef"
      :headerKeys="state.excelTemplateHeaderKey"
      @return="saveExcelData"
  />

  <ExcelManage
    v-show="false"
    ref="excelManageRef"
    :headerKeys="state.excelHeaderKey"
    @return="r => getExcelData(r.sheets)"
  />

  <ExcelUploadModal 
    ref="excelUploadModalRef" 
    :colDefs="state.excelModalColDefs"  
  />

  <ManagerRegModal
    ref="managerRegModalRef"
    call-page="cp"
    @return="
      (r) => (  getMngData(r))
    "
  />

</template>
  
<script setup>   
import { reactive,ref,watch,computed,onBeforeMount } from 'vue';
import ManagerRegModal from "@/components/common/modal/ManagerRegModal.vue";
import FileUpload from '@/components/common/FileUpload.vue';
import DatePicker from '@/components/common/DatePicker.vue'
import SelectCode from '@/components/common/SelectCode.vue';
import Caption from '@/components/common/CaptionList.vue';
import routerCmn from '@/js/vueRouterCmn';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup"
import Row from "primevue/row"
import common from '@/js/common';
import ExcelManage from '@/components/common/MCO_EX_001.vue';
import ExcelTemplateManage from '@/components/common/MCO_EX_004.vue';
import ExcelUploadModal from "@/components/common/modal/ExcelUploadModal.vue";
import ProdClassModal from '@/components/common/modal/ProdClassModal.vue';
import CompanyModal from '@/components/common/modal/CompanyModal.vue';
import WarrantySalesModal from '@/components/common/modal/WarrantySalesModal.vue';
import { useUserStore } from '@/store/user'
const userStore = useUserStore()
import { useCodeStore } from '@/store/code'
const codeStore = useCodeStore()
//공통코드 > api 코드

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { salesOptyEdit, salesOptyInoutListEdit, optyExcelUpload} from '@/api/sales';
import { getProdRevIdList, prodList ,depthProdList ,getProdRevIDYearList} from '@/api/prod';
import { compList ,MkSalesCmpSeq} from '@/api/comp';
import { mngList } from '@/api/mng'
import {codeGrpDtlList} from '@/api/common'

import { router } from '@/router';

const fileUploadRef = ref()
const cmpModalBtnRef = ref()
const salesCmpNmRef = ref()
const endCmpNmBtnRef = ref()
const endCmpNmRef = ref()
const manager1Ref = ref()
const manager2Ref = ref()
const salesNmRef = ref()
const optyModalBtn = ref()
const prodModalBtnRef = ref()
const excelManageRef = ref()
const excelTempManageRef = ref()
const captionRef = ref()
const salesCeoRef = ref()
const prodClassModalRef = ref()
const companyModalRef = ref()
const warrantySalesModalRef = ref()
const excelUploadModalRef = ref()
const wonDateRef = ref()
const poDateRef = ref()
const stgSelectRef = ref()
const taxYnRef = ref()
const collectYnRef = ref() 
const wSalesIdRef = ref()
const managerRegModalRef = ref()
const BRSelectRef = ref()

const allCheck = computed({
    get(){
        return state.inoutRowData.length === state.inoutSelectedRow.length;
    },
    set(newValue){
        state.inoutSelectedRow = newValue ? state.inoutRowData.map((item)=>{return item}) : [];
    }
})


const outcome_sum = computed(()=>{
  let outcome_sum = 0
  state.inoutRowData.forEach((item)=>{
    if(item.outcome_sum){
      item.outcome_sum = typeof item.outcome_sum === 'string' ?  item.outcome_sum.replaceAll(',','') : item.outcome_sum
      outcome_sum += Number(item.outcome_sum)
    }
  })
  return isNaN(outcome_sum) ? 0 : outcome_sum
})

const checkGPUModel = (val)=>{

  return state.gpu_model_prod_list.some((r) =>{
    if(r.class_Id == val){
      return true
    }else{
      return false
    }
  })
}

const income_sum = computed(()=>{
  let income_sum = 0
  state.inoutRowData.forEach((item)=>{
    if(item.income_sum){
      item.income_sum = typeof item.income_sum === 'string' ?  item.income_sum.replaceAll(',','') : item.income_sum
      income_sum += Number(item.income_sum)
    }
  })
  return isNaN(income_sum) ? 0 : income_sum
})

const gm_amt = computed(()=>{
  let outcome_sum_val = Number(outcome_sum.value)
  let income_sum_val = Number(income_sum.value)

  let gm_amt =  outcome_sum_val - income_sum_val 
  return isNaN(Number(gm_amt)) ? 0 : gm_amt // Number(gm_amt)
})

const gm_amt_per = computed(()=>{
  let outcome_sum_val = Number(outcome_sum.value)
  let gm_amt_value = Number(gm_amt.value)

  let gm_amt_per = (gm_amt_value / outcome_sum_val * 100).toFixed(1)
  return isFinite(Number(gm_amt_per)) ? Number(gm_amt_per): 0 
})

const minDate = computed(()=>{
  let minDate = ''
  if(state.salesOptyParams.reg_dt) {
    minDate = state.salesOptyParams.reg_dt
  }else{
    minDate = common.dateFormat(new Date())
  }
  return minDate
})

//aginng (날짜차이 계산)
const aginng = computed(()=>{
  let today = new Date();
  let diffDate;
  if(state.salesOptyParams.reg_dt != null){
    diffDate = Math.abs((today - new Date(state.salesOptyParams.reg_dt).getTime()) / (1000 * 60 * 60 * 24));
  }
  return diffDate ? Math.floor(diffDate) : 0 // 밀리세컨 * 초 * 분 * 시 = 일
})

//매출세금 계산서 Y로 변경 && stage commit,won,close
const monthMinMaxDate = computed(()=>{
  if(state.depthProdList && state.inoutRowData){
    const yList = state.depthProdList.filter(r => r.applicable_yn == 'Y' || r.applicable_yn == 'A')
    const applicableYn = checkApplicableLists(yList,state.inoutRowData)
    if(state.inoutParams.tax_dt && state.inoutParams.tax_yn ==='Y' && (state.salesOptyParams.stage_cd.includes('STG03') ||
             state.salesOptyParams.stage_cd.includes('STG04') ||
             state.salesOptyParams.stage_cd.includes('STG05')) && !applicableYn.isApplicable && !applicableYn.hasAMatch){ 
      return state.inoutParams.tax_dt
    }
  }
})

const checkApplicableLists = (aList, bList) => {
    let hasAMatch = false; 
    let firstYProductName = null; 
    let firstAProductName = null; 
    const bClassIds = new Set(bList.map(item => item.prod_class_id));

    for (const aItem of aList) {
        if (bClassIds.has(aItem.class_Id)) {
            if (aItem.applicable_yn === 'A') {
                hasAMatch = true;
                if (!firstAProductName) { 
                    firstAProductName = aItem.class_nm;
                }
            } else if (aItem.applicable_yn === 'Y') {
                if (!firstYProductName) {
                    firstYProductName = aItem.class_nm;
                }
            }
        }
    }

    if (hasAMatch || firstYProductName) {
        return {
            isApplicable: false,
            productName: hasAMatch ? firstAProductName : firstYProductName,
            hasAMatch: hasAMatch 
        };
    } else {
        return {
            isApplicable: true,
            productName: null,
            hasAMatch: false
        };
    }
};

const getDaysDiff = (date1, date2) => {
  const arbitraryYear = 2000;

  const normalizeDateString = (dateStr) => {
    let tempDateStr = String(dateStr); 

    if (typeof tempDateStr !== 'string') { 
      return null;
    }
    const normalized = tempDateStr.replace(/-/g, '');
    if (normalized.length !== 8) {
      return null;
    }
    return normalized;
  };

  const normalizedDate1 = normalizeDateString(date1);
  const normalizedDate2 = normalizeDateString(date2);

  if (normalizedDate1 === null || normalizedDate2 === null) {
    return NaN;
  }

  const month1 = parseInt(normalizedDate1.substring(4, 6), 10);
  const day1 = parseInt(normalizedDate1.substring(6, 8), 10);
  const month2 = parseInt(normalizedDate2.substring(4, 6), 10);
  const day2 = parseInt(normalizedDate2.substring(6, 8), 10);

  const d1 = new Date(arbitraryYear, month1 - 1, day1);
  const d2 = new Date(arbitraryYear, month2 - 1, day2);

  if (isNaN(d1.getTime()) || isNaN(d2.getTime())) {
    return NaN;
  }

  const diffTime = Math.abs(d2.getTime() - d1.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};


const state = reactive({
  captionTbId : 'sales',
  inoutMaxIndex : 0,
  formatYN: 'Y',
  maxRev : '',
  brIsnull : null,
  resFileList : [],
  searchOptyParams : {
    opty_seq : null,
    sales_id : null
  },
  inoutParams: {
    tax_dt : '',
    tax_yn : '',
    collect_dt : '',
    collect_yn : ''
  },
  salesOptyParams :{
    opty_seq : null,
    sales_id : null,                //영업기회id
    sales_cmp_info_seq : '',      //매출처(회사관리번호로 관리)
    sales_cmp_nm : '',            //매출처이름
    end_user_cmp_info_seq : '',             //endUser(회사관리번호로 관리)
    end_user_cmp_nm : '',             //endUser이름
    employee_id : userStore.user.employeeId,
    manager1 : '',                //담당자1
    manager2 : '',                //담당자2
    sales_nm : '',                //영업기회명
    sales_ceo : userStore.user.userNm ? userStore.user.userNm : '',               //영업대표
    maker_cmp_info_seq : '',                //제조사(회사관리번호로 관리)
    maker_cmp_nm : '',                //제조사이름
    stage_cd : '',                //stage(공통코드)
    bnr_cd : '',                  //Bridge&Risk(공통코드)
    tax_dt : '',                 //매출세금계산서 발행일(일자)
    collect_dt : '',              //수금일(일자) 
    tax_yn : '',                  //발행여부
    collect_yn : '',              //수금여부
    reg_dt : '',              //최초 등록일
    won_dt : '',                 //우선협상자 선정일(일자)
    po_dt:'',                     //po발행일
    custom_po : null,               //고객PO
    prd_info : '',                //상품(납품)정보
    dlv_dt : '',                  //납품완료일
    psp_yn : '',                  //PSP지정여부
    isp_dt : '',                  //검수완료일(일자)
    w_sales_id : '',              //Warranty 영업기회 매핑 id
    w_end_dt : '',                //Warranty End Date(일자)
    w_end_ck : '',                //Warranty End Date 체크(1:체크)
    w_alarm_yn : '',
    ngt_date : '',
    bkmark_yn : 'N',               //즐겨찾기
    memo : '',                    //메모
    outcome_sum : 0,              //총매출금액
    income_sum : 0,               //총매입금액
    gm_amt : 0,                  //GM AMT(매출-매입)
    gm_amt_per : 0,               //GM Amt/매출
    tmp_yn : 'N',
    cap_seq : 0,
    tb_id : 'sales',
    depthProdList : [],
    attachFileVO: {
      file_div_id: "10",
      file_seq: "", //추가 된 파일 seq 전송
      del_file_seq: "", // 삭제해야 할 파일 seq 전송
    },
  },
  excelGridColumn1: [
    {header: "상품",rowspan : 1,colspan : 3},
    {header: "리비전번호",rowspan : 2,colspan : 1},
    {header: "상품ID",rowspan : 2,colspan : 1},
    { header: "활성화 여부",rowspan : 2,colspan : 1},
  ],
  prodList: [],
  excelData : [],
  //파일 첨부 데이터()
  fileList: [],
  delFileList: [],
  searchParam:{
    buy_cmp_info_nm :'',
    goods_nm:''
  },
  prodCodeLev : 3,
  clickKey : {
    key : '',
    target : '',
    index : null
  }, 
  searchStgParam : {
    cd_gr : 'STG_CD'
  },
  warMapping : false,
  tax_dt_s : '',
  tax_dt_e : '',
  prodRevId : '',
  mkCmpSeq : '',
  gpu_model_prod_list:[],
  //inoutGridMainCtgy : [
    // 정렬을 위해서 밑으로 컬럼을 넣었다. 그런데 현재 1,2,3 단계 작동시에 데이터 입력이 중요하다.
  //  ],

  excelModalColDefs: [
    { header: "제조사", field: "made_cmp_info_nm", req: true},
    { header: "매입처", field: "buy_cmp_info_nm", req: true},
    { header: "상품", field: "class_nm", req: true},
    { header: "매출금액(원)", field: "outcome_sum"},
    { header: "매입금액(원)", field: "income_sum", req: true},
    { header: "매출세금계산서 발행일 (YYYY-MM-DD)", field: "tax_dt",type:'date' },
    { header: "발행여부", field: "tax_yn"},
    { header: "수금일 (YYYY-MM-DD)", field: "collect_dt",type:'date' },
    { header: "수금여부", field: "collect_yn"},
    { header: "매입세금계산서 발행일(YYYY-MM-DD)", field: "tax_sale_dt", type: 'number',type:'date' },
    { header: "매입여부", field: "tax_sale_yn"},
    { header: "지급일(YYYY-MM-DD)", field: "pay_dt",type:'date' },
    { header: "지급여부", field: "pay_yn"},
  ],

  inoutGridSubCtgy : [
      {header : '제조사', field : 'made_cmp_info_nm',rowspan:2,colspan:1,style:{minWidth : '180px'},sortable:true},
      {header : '매입처', field : 'buy_cmp_info_nm',rowspan:2,colspan:1,style:{minWidth : '180px'}},
      {header : '상품 1단계' ,field : 'class_nm1', rowspan:1,colspan:1,style:{textAlign : 'center',minWidth : '150px'}},
      {header : '상품 2단계' ,field : 'class_nm2', rowspan:1,colspan:1,style:{textAlign : 'center',minWidth : '150px'}},
      {header : '상품 3단계' ,field : 'class_nm3', rowspan:1,colspan:1,style:{textAlign : 'center',minWidth : '150px'}},  
      {header : '매출금액(원)' ,field : 'outcome_sum',  rowspan:2,colspan:1,style:{textAlign : 'right',minWidth : '150px'}},
      {header : '매입금액(원)' ,field : 'income_sum',  rowspan:2,colspan:1,style:{textAlign : 'right',minWidth : '150px'}},
  
      {header : '매입세금계산서 발행일' , field : 'tax_sale_dt',rowspan:2,colspan:1,style:{textAlign : 'center',minWidth : '200px'}},
      {header : '매입여부' , field : 'tax_sale_yn',rowspan:2,colspan:1,style:{textAlign : 'center',minWidth : '60px'}},
      {header : '지급일' ,field : 'pay_dt',  rowspan:2,colspan:1,style:{textAlign : 'center',minWidth : '200px'}},
      {header : '지급여부' , field : 'pay_yn', rowspan:2,colspan:1,style:{textAlign : 'center',minWidth : '55px'}},
  ],
  inoutGridColumn: [
    { header: "제조사",field : 'made_cmp_info_nm', style: {minWidth:'120px'}, sortable:true, visible:true},
    { header: "매입처",field : 'buy_cmp_info_nm', style: {minWidth:'120px'}, sortable:true, visible:true},
    { header: "상품1단계", field: 'class_nm1', style: { minWidth: '100px' }, sortable: true, visible:true },
    { header: "상품2단계", field: 'class_nm2', style: { minWidth: '100px' }, sortable: true, visible:true },
    { header: "상품3단계", field: 'class_nm3', style: { minWidth: '100px' }, sortable: true, visible:true },
    { header: "GPU Model", field: 'gpu_model_nm', style: { minWidth: '100px' }, sortable: true, visible: false },
    { header: "GPU 수량", field: 'gpu_model_qty', style: { textAlign : 'right',minWidth: '120px' }, sortable: true, visible: false},
    { header: "매출금액(원)", field : 'outcome_sum', style: {textAlign : 'right', minWidth:'120px'}, sortable:true, visible:true},
    { header: "매입금액(원)",field : 'income_sum', style: {textAlign : 'right', minWidth:'120px'}, sortable:true, visible:true},
    { header: "Gross Margin",field : 'gm_amt', style: {textAlign : 'right', minWidth:'140px'}, sortable:true, visible:true},
    { header: "GM(%)",field : 'gm_amt_per', style: {textAlign : 'center', minWidth:'70px'}, sortable:true, visible:true},
    // 2025-03-27
    // { header: "매출세금계산서 발행일", field : 'tax_dt', style: {textAlign : 'center', minWidth:'140px'}, sortable:true},
    // { header: "발행여부",field : 'tax_yn', style: {textAlign : 'center', minWidth:'70px'}, sortable:true},
    // { header: "수금일", field : 'collect_dt', style: {textAlign : 'center', minWidth:'140px'}, sortable:true},
    // { header: "수금여부", field : 'collect_yn', style: {textAlign : 'center', minWidth:'70px'}, sortable:true},

    { header: "매입세금계산서 발행일", field : 'tax_sale_dt', style: {textAlign : 'center', minWidth:'140px'}, sortable:true, visible:true},
    { header: "매입여부", field : 'tax_sale_yn', style: {textAlign : 'center', minWidth:'70px'}, sortable:true, visible:true},
    { header: "지급일",field : 'pay_dt', style: {textAlign : 'center', minWidth:'140px'}, sortable:true, visible:true},
    { header: "지급여부", field : 'pay_yn', style: {textAlign : 'center', minWidth:'70px'}, sortable:true, visible:true},
    // { header: "취소사유", field : 'memo', style: {textAlign : 'center', minWidth:'70px'}, sortable:true},
    
  ],
  inoutRowData : [],
  inoutSearchRowData : [],
  inoutSelectedRow : [],
  successCnt : 0,
  recentProdRev : '',
  pageType : 'insert',
  excelHeaderKey : [
    'made_cmp_info',
    'buy_cmp_info',
    'class_id',
    'outcome_sum',
    'income_sum',
    'tax_dt',
    'tax_yn',
    'collect_dt',
    'collect_yn',
    'tax_sale_dt',
    'tax_sale_yn',
    'pay_dt',
    'pay_yn',
  ],
  excelTemplateHeaderKey : [
    'end_user_cmp_info_seq',
    'sales_cmp_info_seq',
    'sales_nm',
    'manager1',
    'manager2',
    'bnr_cd',
    'stage_cd',
    'won_dt',
    'po_dt',
    'tax_dt',
    'tax_yn',
    'collect_dt',
    'collect_yn',
    'custom_po',
    'memo',
    'prd_info',
    'dlv_dt',
    'psp_yn',
    'isp_dt',
    // 'w_sales_id',
    // 'w_end_ck',
    'w_end_dt',
    'made_cmp_info_seq',
    'buy_cmp_info_seq',
    'prod_class_id',
    'gpu_model_nm',
    'gpu_model_qty',
    'outcome_sum',
    'income_sum',
    'tax_sale_dt',
    'tax_sale_yn',
    'pay_dt',
    'pay_yn'
  ],
  inoutKey : [
    'made_cmp_info_nm',
    'buy_cmp_info_seq',
    'buy_cmp_info_nm',
    'made_cmp_info_seq',
    'prod_class_id',
    'income_sum',
    'outcome_sum',
    'gpu_model_nm',
    'gpu_model_qty'
  ],
  optyKey : [
    'sales_cmp_info_seq',
    'sales_nm',
    'manager1',
    'stage_cd',
    'won_dt', 
    'po_dt',
    'collect_yn',
    'collect_dt',
    'tax_dt',
    'tax_yn',
    
  ],
  optykey2 : [
    'made_cmp_info_seq',
    'buy_cmp_info_seq',
    'prod_class_id',
    'outcome_sum',
    'income_sum'
  ],
  optykey3 : [
    'tax_sale_dt',
    'tax_sale_yn',
    'pay_dt',
    'pay_yn'
  ],
  koreaOpty : [
    {key :'end_user_cmp_info_seq' , name : 'End User'},
    {key :'sales_cmp_info_seq' , name : '매출처'},
    {key :'sales_nm' , name : '영업기회명'},
    {key :'manager1' , name : '담당자'},
    {key :'stage_cd' , name : 'Stage'},
    {key :'won_dt' , name : '우선협상자 선정일'},
    {key :'po_dt' , name : 'PO발행일'},
    {key :'tax_dt' , name : '매출세금계산서 발행일'},
    {key :'made_cmp_info_seq' , name : '제조사'},
    {key :'buy_cmp_info_seq' , name : '매입처'},
    {key :'prod_class_id' , name : '상품'},
    {key :'gpu_model_nm' , name : 'GPU 모델'},
    {key :'gpu_model_qty' , name : 'GPU 모델 수량'},
    {key :'outcome_sum' , name : '매출금액'},
    {key :'income_sum' , name : '매입금액'},
    {key :'tax_yn' , name : '발행여부'},
    {key :'collect_dt' , name : '수금일'},
    {key :'collect_yn' , name : '수금여부'},
    {key :'tax_sale_dt' , name : '매입세금계산서 발행일'},
    {key :'tax_sale_yn' , name : '매입여부'},
    {key :'pay_dt' , name : '지급일'},
    {key :'pay_yn' , name : '지급여부'},
  ],
  fs_year:'',
  gpumodelYn:false,
})

watch(
  () => state.inoutRowData.length,(newVal,oldVal)=>{
    searchInoutList()
  },
)

watch(
  () => state.searchParam.buy_cmp_info_nm,(newVal,oldVal)=>{
    searchInoutList()
  },
)

watch(
  () => state.searchParam.goods_nm,(newVal,oldVal)=>{
    searchInoutList()
  },
)

watch(
  () => state.salesOptyParams.bnr_cd,(newVal,oldVal)=>{
    if(state.salesOptyParams.bnr_cd && state.salesOptyParams.bnr_cd !==''){
      if(state.salesOptyParams.bnr_cd == 'BNR03'){
        if(state.salesOptyParams.stage_cd !=='STG03'&& state.salesOptyParams.stage_cd !=='STG06'&& state.salesOptyParams.stage_cd !=='STG07'){
          alert('Bridge(B),Risk(R)의 Risk는 Stage가 Commit(Lost,Omit)일때 가능합니다.\n')
          state.salesOptyParams.bnr_cd = ''
          BRSelectRef.value.nullDefault();
          BRSelectRef.value.focus();
        }
      }else if(state.salesOptyParams.bnr_cd== 'BNR02'){
        if(state.salesOptyParams.stage_cd !=='STG02' && state.salesOptyParams.stage_cd !=='STG06' && state.salesOptyParams.stage_cd !=='STG07'){
          alert('Bridge(B),Risk(R)의 Bridge는 Stage가 Upside(Lost,Omit)일때 가능합니다.\n')
          state.salesOptyParams.bnr_cd = ''
          BRSelectRef.value.nullDefault();
          BRSelectRef.value.focus();
        }
      }
    }
  },
)

watch(
  ()=>state.salesOptyParams.stage_cd,(newVal,oldVal)=>{
    if(state.salesOptyParams.stage_cd && state.salesOptyParams.stage_cd !==''){
      if(state.salesOptyParams.bnr_cd == 'BNR03'){
        if(state.salesOptyParams.stage_cd !=='STG03'&& state.salesOptyParams.stage_cd !=='STG06'&& state.salesOptyParams.stage_cd !=='STG07'){
          alert('Bridge(B),Risk(R)의 Risk는 Stage가 Commit(Lost,Omit)일때 가능합니다.\n')
          state.salesOptyParams.stage_cd = ''
          stgSelectRef.value.nullDefault();
          stgSelectRef.value.focus();
        }
      }else if(state.salesOptyParams.bnr_cd== 'BNR02'){
        if(state.salesOptyParams.stage_cd !=='STG02' && state.salesOptyParams.stage_cd !=='STG06' && state.salesOptyParams.stage_cd !=='STG07'){
          alert('Bridge(B),Risk(R)의 Bridge는 Stage가 Upside(Lost,Omit)일때 가능합니다.\n')
          state.salesOptyParams.stage_cd = ''
          stgSelectRef.value.nullDefault();
          stgSelectRef.value.focus();
        }
      }
    }
  },
)

watch(
  () => state.inoutParams.tax_dt,
    (newVal,oldVal) => {
      if(newVal){
        getProdRevId();
        getList2();
        state.fs_year = state.inoutParams.tax_dt.substring(0,4)
      }
      
    }
)

onBeforeMount(async()=>{
  await searchProdList();
  await getMkCmpSeq();
  await getList2();   
})

const getMkCmpSeq = async()=>{
  const res = await MkSalesCmpSeq();
  state.mkCmpSeq = res.rtn.cmp_info_seq;
}

//북마크 체크시 실행 함수
const changeBkmark =()=>{
  if(state.salesOptyParams.bkmark_yn === 'Y'){
    state.salesOptyParams.bkmark_yn = 'N'
  }else{
    state.salesOptyParams.bkmark_yn = 'Y'
  }
}


const getFileList = (res) =>{
  if (res && res?.length > 0) {
    res.forEach((file) => {
      state.fileList.push(file.file_seq);
    });
  }
  saveOpty();

}

const getDeleteFile = (res) =>{
  state.delFileList.push(res.file_seq);
}

const openMngModal = (key) =>{
  state.clickKey.key = key
  managerRegModalRef.value.openModal()
}


const openCmpModal = (val) =>{
  state.clickKey.key = val.key
  state.clickKey.target = val.target
  state.clickKey.index = val.index
  companyModalRef.value.openModal()
}

const prodResList = ref([])

//매입매출정보 조회
async function searchInoutList(){
  let searchList = [...state.inoutRowData]

  //매입매출 원본 리스트에서 매입처, 상품이름 검색 filter 로직
  searchList = state.inoutRowData.filter((item)=>{
    let flag = true
    
    //매입처 이름 조건 filter
    if(state.searchParam.buy_cmp_info_nm){
      flag = item.buy_cmp_info_nm ? item.buy_cmp_info_nm.includes(state.searchParam.buy_cmp_info_nm) : false
      //flag false면 아래로직까지 가지말고 거르기
      if(!flag) return
    }

    //상품 이름 검색 (뎁스가 어디까지 늘어날지몰라 모든 뎁스 유사어 있으면 검색리스트 추가)
    if(state.searchParam.goods_nm){
      //검색어가 있고 prod_level이 없는 경우 검색 제외
      //prod_level은 일괄등록, 매입매출 상품 적용할때(updateParam 함수 참조) 추가됨
      if(item.prod_level){
        for(var i=1; i<=item.prod_level; i++){
          let classNm = item[`class_nm${i}`].toLowerCase()
          flag = classNm ? classNm.includes(state.searchParam.goods_nm.toLowerCase()) : false
          if(flag) break;
        }
      }else{
          flag = false
      }
    }


    if(flag){
      return item
    }
  })

  state.searchInoutList = searchList || []
  
}


const getGMandGMper = (list) => {

let dataList = state.inoutRowData

dataList.map((item,index) =>{
  
  let a = Number(item.income_sum)
  let b = Number(item.outcome_sum)

  item['gm_amt'] = b - a
  const gm_amt_per = item['gm_amt'] / Number(item['outcome_sum']) * 100
   item['gm_amt_per']= `${Math.round(isFinite(Number(gm_amt_per)) ? Number(gm_amt_per): 0 )}%`
})
state.inoutRowData = dataList

// if(field === 'outcome_sum' || field === 'income_sum'){
//       data['gm_amt'] = Number(newData['outcome_sum']) - Number(newData['income_sum'])
//       data['gm_amt_per'] = data['gm_amt'] / Number(newData['outcome_sum']) * 100
//     }
}


//모달 선택버튼으로 닫혔을 경우 선택값 update
//회사,영업기회,상품분류 모달
const updateParam = (type,returnData) =>{
  if(!returnData) return


  if(type === 'company'){
    //매출처,end_user,제조사 매핑

    let companyDeptName = returnData.cmp_dvsn_nm ? `${returnData.cmp_nm}(${returnData.cmp_dvsn_nm})` : `${returnData.cmp_nm}`

    if(state.clickKey.target === 'sales'){
      state['salesOptyParams'][`${state.clickKey.key}_nm`] = companyDeptName
      state.salesOptyParams[`${state.clickKey.key}_info_seq`] = returnData.cmp_info_seq
    }
    //매입매출처 정보 > 제조사,매입처 매핑
    else if(state.clickKey.target === 'inout'){
      state.inoutRowData.some((item)=>{
        if(item.index === state.clickKey.index){
          item[`${state.clickKey.key}_cmp_info_nm`] = companyDeptName // `${returnData.cmp_nm}(${returnData.cmp_dvsn_nm})`
          item[`${state.clickKey.key}_cmp_info_seq`] = returnData.cmp_info_seq
          return true
        }
      })
    }
    
    state.clickKey = {key : '',target : ''}

  }else if(type == 'opty'){

    state.salesOptyParams.w_sales_id = returnData.sales_id

  }else if(type == 'prod'){
    //선택한 행이 있는 경우 (returnData : 선택한 행 데이터)

    if(returnData.codeFam.length>0){
      
      //기존 단계별 class_nm을 ''으로 설정
      state.inoutRowData.some((item)=>{
        if(item.index === state.clickKey.index){
          Object.keys(item).forEach((key)=>{
            if(key.includes('class_nm')){
              item[key] = ''
            }
          })

          returnData.codeFam.forEach((code,index)=>{
            item[`class_nm${index+1}`] = code['class_nm']
          })

          item['prod_rev_id'] = returnData.rev_id
          item.prod_class_id = returnData.selectKey
          item.prod_level = returnData.codeFam.length
          //현재 보여지는 단계보다 높을경우 inout 그리드 상품 단계 컬럼 추가
          //createInoutCol(returnData.codeFam)
          
          return true
        }
      })
      const hasAnyGpuModel = state.inoutRowData.some(item => 
        state.gpu_model_prod_list.some(gpu => gpu.class_Id === item.prod_class_id)
      );
      state.gpumodelYn = hasAnyGpuModel;
      state.inoutGridColumn.forEach(column => {
        if (column.field === 'gpu_model_nm' || column.field === 'gpu_model_qty') {
            column.visible = hasAnyGpuModel;
        }
      });
    }
   

    
  }
 
  searchInoutList()
}

const createInoutCol = (codeFam)=>{
  if(state.prodCodeLev <  codeFam.length){
      for(var i=(state.prodCodeLev+1); i<=codeFam.length; i++){
        //현재 상품 뎁스 2단계 초과된 상품코드 등록 시 그리드 컬럼에 새로운 단계 컬럼 추가
        //let col = {header: `${i}단계` , field: `class_nm${i}`,style:{minWidth:'150px'}}

        //상단 헤더 컬럼(colspan 늘려야함)
        // state.inoutGridMainCtgy.map((item)=>{
        //   if(item.header == '상품'){
        //     item.colspan = i
        //   }
        //   return item
        // })

        state.inoutGridColumn.map((item2,index)=>{
          if(item2.field == `class_nm${i-1}`){
            let SubCtgy = {field : `class_nm${i}`}
            state.inoutGridColumn.splice(index+1, 0, SubCtgy);
          }
          return item2
        })

        //하단 헤더 컬럼
       //state.inoutGridSubCtgy.splice(i-1, 0, col);
        
      }
      state.prodCodeLev = codeFam.length

  }
}

const checkValidation = async(tmpYn) =>{
  try{
    let msg = codeStore.getCodeMsg("77777");
    state.salesOptyParams.tmp_yn = tmpYn

    if(tmpYn === 'N'){
      if (!state.salesOptyParams.end_user_cmp_info_seq.trim() || !state.salesOptyParams.end_user_cmp_nm.trim()) {
        //endUser
        endCmpNmRef.value.input.focus()
        alert(msg);
        return;
      }
      
      if (!state.salesOptyParams.sales_cmp_info_seq.trim() || !state.salesOptyParams.sales_cmp_nm.trim()) {
        //매출처
        salesCmpNmRef.value.input.focus()
        alert(msg);
        return;
      }

      if (!state.salesOptyParams.manager1.trim()) {
        //담당자1
        manager1Ref.value.input.focus()
        alert(msg);
        return;
      }

      if (state.salesOptyParams.manager2.length > 10  || state.salesOptyParams.manager1.length > 10) {
        //담당자1
        // manager1Ref.value.input.focus()
        alert('담당자 10자 이하만 가능합니다.');
        return;
      }

      if (!state.salesOptyParams.sales_nm.trim() || state.salesOptyParams.sales_nm.length > 100) {
        //영업기회명
        salesNmRef.value.input.focus()
        alert(msg);
        return;
      }


      if (!state.salesOptyParams.sales_ceo.trim()) {
        //영업대표
        salesCeoRef.value.input.focus()
        alert(msg);
        return;
      }

      //stage 
      if(!state.salesOptyParams.stage_cd){
        stgSelectRef.value.focus()
        alert('stage를 선택해주세요')
        return
      }

      
      if (!state.salesOptyParams.won_dt) {
        //wonDateRef.value.focus()
        //우선협상자 선정일
        alert('우선협상자 선정일(Won Date)을 입력하세요')
        return;
      }

      if (!state.salesOptyParams.po_dt) {
        //PO 발행일
        alert('PO발행일을 입력하세요')
        return;
      }

      //매출세금계산서 발행일
      if(!state.inoutParams.tax_dt){
        alert('매출세금계산서 발행일을 입력하세요')
        return;
      }
      //발행여부 
      if(!state.inoutParams.tax_yn){
        taxYnRef.value.focus()
        alert('발행여부를 선택하세요')
        return;
      }
      
      //수금일
      if(!state.inoutParams.collect_dt){
        alert('수금일을 입력하세요')
        return;
      }

      //수금여부 
      if(!state.inoutParams.collect_yn){
        collectYnRef.value.focus()
        alert('수금여부를 선택하세요')
        return;
      }

      
      if(state.salesOptyParams.custom_po){
        if (isNaN(Number(state.salesOptyParams.custom_po)) || state.salesOptyParams.custom_po.length > 19) {
          alert('고객PO#는 19자리이하 숫자만 가능합니다.')
          return;
        }
      }
      
      if(state.warMapping && !state.salesOptyParams.w_sales_id){
        alert('매핑할 Warranty 영업기회를 선택해주세요.')
        wSalesIdRef.value.input.focus()
        return
      }

      if( state.salesOptyParams.w_end_ck == true){
          if(state.salesOptyParams.w_end_dt == null || state.salesOptyParams.w_end_dt ==undefined || state.salesOptyParams.w_end_dt == ""){
            alert('Warranty End Date를 입력하세요')
            return
          }
        }

      let res = await captionRef.value.checkValidation()
      if(!res){
        return
      }

      let prodFlag = false
      let warnMsg = '매입매출처 정보는 모두 필수값입니다.'
      state.inoutRowData.some((item)=>{
        state.inoutKey.some((key)=>{
          if(key === 'prod_class_id' && item['prod_class_id']?.length !== 12){
          warnMsg = '매입매출 상품분류를 3단계로 선택해주세요.'
          prodFlag = true
          return prodFlag
          }
          else if(key === 'made_cmp_info_nm' && !item[key]){
            warnMsg = '제조사를 입력해주세요.'
          prodFlag = true
          return prodFlag
          }
          else if(key === 'buy_cmp_info_nm' && !item[key]){
            warnMsg = '매입처를 입력해주세요.'
          prodFlag = true
          return prodFlag
          }
          if(key ==='gpu_model_nm' && !item[key] && checkGPUModel(item['prod_class_id'])){
            warnMsg = 'GPU Model을 입력해주세요'
            prodFlag = true
            return prodFlag
          }
          if(key ==='gpu_model_qty' && item[key] <= 0 && checkGPUModel(item['prod_class_id'])){
            warnMsg = 'GPU 수량을 입력해주세요'
            prodFlag = true
            return prodFlag
          }
        })
      })

      let applicableYn;
      if(state.depthProdList && state.inoutRowData){
          const yList = state.depthProdList.filter(r => r.applicable_yn == 'Y' || r.applicable_yn == 'A')
          applicableYn = checkApplicableLists(yList,state.inoutRowData)
      }

      if(state.inoutParams.tax_dt && state.inoutParams.tax_yn ==='Y' && (state.salesOptyParams.stage_cd.includes('STG03') ||
             state.salesOptyParams.stage_cd.includes('STG04') ||
             state.salesOptyParams.stage_cd.includes('STG05')) && !applicableYn.isApplicable){
        if(!state.salesOptyParams.isp_dt && !state.salesOptyParams.w_end_dt){
          warnMsg = `${applicableYn.productName} 상품이 입력된 경우 검수완료일과 계약만료일은 필수로 입력해야 합니다.`
          prodFlag = true
        }else if(!state.salesOptyParams.isp_dt && state.salesOptyParams.w_end_dt){
          warnMsg = `${applicableYn.productName} 상품이 입력된 경우 검수완료일은 필수로 입력해야 합니다.`
          prodFlag = true
        }else if(state.salesOptyParams.isp_dt && !state.salesOptyParams.w_end_dt){
          warnMsg = `${applicableYn.productName} 상품이 입력된 경우 계약만료일은 필수로 입력해야 합니다.`
          prodFlag = true
        }else{
          if (!applicableYn.hasAMatch) {
            if (state.inoutParams.tax_dt && state.salesOptyParams.isp_dt) {
              const diffIspDt = getDaysDiff(state.inoutParams.tax_dt, state.salesOptyParams.isp_dt);
              if (diffIspDt > 31) {
                prodFlag = true;
                warnMsg = `매출세금계산서일자(${state.inoutParams.tax_dt})와 검수완료일(${state.salesOptyParams.isp_dt})의 날짜 차이가 ±31일 범위를 벗어납니다.`;
              }
            }
            if (state.inoutParams.tax_dt && state.salesOptyParams.w_end_dt) {
              const diffWEndDt = getDaysDiff(state.inoutParams.tax_dt, state.salesOptyParams.w_end_dt);
              const taxDtObj = new Date(state.inoutParams.tax_dt);
              const wEndDtObj = new Date(state.salesOptyParams.w_end_dt);
              if (diffWEndDt > 31) {
                prodFlag = true;
                warnMsg = `매출세금계산서일자(${state.inoutParams.tax_dt})와 계약만료일(${state.salesOptyParams.w_end_dt})의 날짜가 ±31일 범위를 벗어납니다.`;
              }
            }
          } 
        }
      }

      if(prodFlag){
        alert(warnMsg)
        return
      }
      
    }
    
    let saveMsg = '등록하시겠습니까?'
    if(tmpYn === 'Y'){
      saveMsg = '임시저장일 경우 첨부파일은 저장이 안됩니다.임시저장하시겠습니까?'
    }
    if(!confirm(saveMsg)) return

    saveOpty(tmpYn);

    
  }catch(e){
    console.log(e)
    alert('영업기회 저장을 실패했습니다.')
    // routerCmn.routerPush('/sr/MSR_SO_002')
  }
  

}

const inout_opt_seq = ref(null)
const inout_sale_id = ref(null)
const saveOpty = async(tmpYn) =>{
  tmpYn = tmpYn || state.salesOptyParams.tmp_yn
  if(tmpYn === 'N'){
    let tmpFiles = fileUploadRef.value.state.tmpFileList;

    //파일 첨부 데이터가 있는지 확인
    if (tmpFiles.length > 0) {
        //임시파일이 있으면 실제 경로 저장
        await fileUploadRef.value.uploadFile("opty/file");
        return
    }
    if (state.fileList.length > 0) {
      state.salesOptyParams.attachFileVO.file_seq = state.fileList.toString();
    }

    if (state.delFileList.length > 0) {
      state.salesOptyParams.attachFileVO.del_file_seq = state.delFileList.toString();
    }
  }else{
    state.salesOptyParams.tb_id = 'sales_imsi'
    state.captionTbId = 'sales_imsi'
  }
  
  // if( state.salesOptyParams.w_end_ck == false && (state.salesOptyParams.w_end_dt != null || state.salesOptyParams.w_end_dt !=undefined || state.salesOptyParams.w_end_dt != "")){
  //   state.salesOptyParams.w_end_ck = true
  // }


  state.salesOptyParams.w_end_ck = state.salesOptyParams.w_end_ck ? 1 : 0

  if(state.salesOptyParams.w_end_ck == '1'){
    state.salesOptyParams.w_alarm_yn = 'Y'
  }else{
    state.salesOptyParams.w_alarm_yn = 'N'
  }

  if(state.salesOptyParams.warMapping){
    state.salesOptyParams.w_alarm_yn = 'N'
  }

  state.salesOptyParams.outcome_sum = outcome_sum.value
  state.salesOptyParams.income_sum = income_sum.value
  state.salesOptyParams.gm_amt = gm_amt.value
  state.salesOptyParams.gm_amt_per = gm_amt_per.value
  //dt format
  state.salesOptyParams.tax_dt = state.salesOptyParams.tax_dt.replaceAll('-','')
  state.salesOptyParams.collect_dt = state.salesOptyParams.collect_dt.replaceAll('-','')
  state.salesOptyParams.won_dt = state.salesOptyParams.won_dt.replaceAll('-','')
  state.salesOptyParams.po_dt = state.salesOptyParams.po_dt.replaceAll('-','')
  state.salesOptyParams.dlv_dt = state.salesOptyParams.dlv_dt.replaceAll('-','')
  state.salesOptyParams.isp_dt = state.salesOptyParams.isp_dt.replaceAll('-','')
  state.salesOptyParams.w_end_dt = state.salesOptyParams.w_end_dt.replaceAll('-','')

  state.salesOptyParams.custom_po = isNaN(Number(state.salesOptyParams.custom_po)) ? 0 : Number(state.salesOptyParams.custom_po)
  
  state.inoutRowData.map((item) => { // inout 으로 opty 의 컬럼 4개를 넘길 수 있도록 하기 
    item.collect_dt = state.inoutParams.collect_dt.replaceAll('-','');
    item.collect_yn = state.inoutParams.collect_yn;
    item.tax_dt = state.inoutParams.tax_dt.replaceAll('-',''); 
    item.tax_yn = state.inoutParams.tax_yn; 
  })
  let editInoutList = [...state.inoutRowData]
  let params = {...state.salesOptyParams}

  try {
    setIsLoading(true)
    const res = await salesOptyEdit(params)

    if(res.code !== '0000'){
      alert('영업기회 저장에 실패했습니다.다시 시도해주세요')
      return
    }

    //복사등록일때 캡션에 SEQ번호 있으면 업데이트됨으로 공백으로 초기화 그 외는 등록,수정
    let cap_seq;
    let tbId;
    if(tmpYn === 'Y'){
      cap_seq = res.rtn.ims_seq
      tbId = 'sales_imsi'
    }else{
      cap_seq = res.rtn.opt_seq
      tbId = 'sales'
    }

    inout_opt_seq.value = cap_seq
    inout_sale_id.value = res.rtn.sales_id || null

    if(editInoutList?.length > 0){
      const inoutRes = await saveInout(editInoutList)
      if(inoutRes.rtn.rtn !== 'OK'){
        alert('매입매출 저장에 실패했습니다.')
        return
      }
    }else{
      alert('매입매출을 입력해주세요.')
      return
    }

    const capRes = await captionRef.value.saveTempCapCtnt(cap_seq,tbId)
    if(capRes.code !== '0000'){
      alert('캡션 저장에 실패했습니다.')
      return
    }


    alert('영업기회 저장에 성공했습니다.')

    
    if(state.salesOptyParams.tmp_yn === 'Y'){
        router.push({
          path : '/sr/MSR_SO_003',
          state : {ims_seq: res.rtn.ims_seq}
        })
    }else{
        routerCmn.routerPush('/sr/MSR_SO_002')
    }

    
  } catch (err) {
    console.log(err)
    alert('저장을 실패했습니다.')
  } finally {
    setIsLoading(false)
  }
}

//매입매출 정보 저장
const saveInout = async(editInoutList)=>{
  if(!editInoutList)routerCmn.routerPush('/sr/MSR_SO_002')

  for(let param of editInoutList){
    state.excelHeaderKey.forEach((key)=>{
      if(key.includes('_dt') || key.includes('_yn')){
        if(param[key] === 'N/A' || !param[key])param[key] = ''
      }
    })


    param.tmp_yn = state.salesOptyParams.tmp_yn
    //임시저장(tmp_yn :Y일때는 ims_seq로 값 초기화)
    if(state.salesOptyParams.tmp_yn === 'Y') {
      param.ims_seq = inout_opt_seq.value
    }else{
      param.sales_id = inout_sale_id.value
      param.opty_seq = inout_opt_seq.value
    }
   
    param.opty_inout_seq = param.opty_inout_seq || ''
    param.tax_sale_dt = param.tax_sale_dt.replaceAll(/-|NaN/gi,'')
    param.pay_dt = param.pay_dt.replaceAll(/-|NaN/gi,'')
    
    param.tax_dt = param.tax_dt.replaceAll(/-|NaN/gi,'')
    param.collect_dt = param.collect_dt.replaceAll(/-|NaN/gi,'')
  }

  let params = {
    salesOptyInoutListVO : editInoutList
  }
  try {
    setIsLoading(true)
    const res = await salesOptyInoutListEdit(params)
    return res
    // routerCmn.routerPush('/sr/MSR_SO_002')
  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }
}


const openOptyModal = async() =>{
  if(state.warMapping == true){
    warrantySalesModalRef.value.openModal()
  }else{
    state.salesOptyParams.w_sales_id = ''
  }
}


const priceToString = (item) => {
    return common.checkNumberComma(item)
}


//매입매출 정보 그리드 행추가
const addInoutData = ()=>{
  if(!state.inoutParams.tax_dt){
    alert('매출세금계산서 발행일를 먼저 입력해주세요.')
    return
  }
  let param = {
    index : state.inoutMaxIndex,
    opty_inout_seq : '',
    made_cmp_info_nm : '',
    made_cmp_info_seq : '',
    buy_cmp_info_nm : '',
    buy_cmp_info_seq : '',
    prod_rev_id : state.recentProdRev,
    prod_class_id : '',
    outcome_sum : 0,
    income_sum : 0,
    gpu_model_nm : '',
    gpu_model_qty : 0,

    tax_dt : '',
    tax_yn : '',
    collect_dt : '',
    pay_yn:'',

    ins_yn : '',
    tax_sale_yn : '',
    tax_sale_dt : '',
    purchase_yn : '',
    pay_dt : '',
  }
  state.inoutMaxIndex += 1
  state.inoutRowData.push(param)
}

//dataGrid 셀 편집 완성시 콜백 함수
const onCellEditComplete = (event)=>{
  let { data,value ,newValue, field } = event;

  if(field !== 'made_cmp_info_nm' && field !== 'buy_cmp_info' && field !== 'class_id' && !field.includes('class_nm')){
  
    if(field === 'tax_dt'){
      if(data['collect_dt'] && newValue > data['collect_dt']){
        alert('수금일은 매출세금계산서 발행일보다 빠를 수 없습니다.수금일을 다시 입력해주세요.')
        data['collect_dt'] = null
      }
    }else if(field === 'tax_sale_dt'){
      if(data['pay_dt'] && newValue > data['pay_dt']){
        alert('지급일은 매입 세금계산서 발행일보다 빠를 수 없습니다.지급일을 다시 입력해주세요.')
        data['pay_dt'] = null
      }
    }


    if(field === 'outcome_sum' || field === 'income_sum') newValue = isNaN(Number(newValue)) ? 0 : Number(newValue)
    data[field] = newValue;
  }
  getGMandGMper()
  searchInoutList()
}



//상품 모달 open
const openProdModal = (val)=>{
  state.clickKey.key = val.key
  state.clickKey.target = val.target
  state.clickKey.index = val.index
  prodClassModalRef.value.openModal()
}

const deleteInoutData = async ()=>{
  if(!confirm('정말 삭제하시겠습니까?')) return
  try {
    let params = {
      deleteIndex : []
    }
    
    for(let item of state.inoutSelectedRow){
      //db에 있는 데이터 추출
      if(item.opty_inout_seq){
        state.salesOptyInoutListVO.push({opty_inout_seq :item.opty_inout_seq,ims_seq : state.searchOptyParams.ims_seq || null})
      }
      params.deleteIndex.push(item.index)
    }
    state.inoutRowData = state.inoutRowData
      .filter(inoutData => !params.deleteIndex.includes(inoutData.index))
      .map((newInoutData, newIndex) => ({
        ...newInoutData,
        index: newIndex
      }));
    state.inoutMaxIndex = state.inoutRowData.length;

  } catch (err) {
    console.error(err)
    alert('매입매출 삭제중 오류가 발생했습니다.')
  } finally {
    state.inoutSelectedRow = []
  }

}

//매입매출 목록 다운로드
const inoutExcelDown = ()=>{
  let fileNm = '매입매출 목록'
  let inoutList = state.inoutRowData;

  let header = [
    {header : '매입매출 그룹', key:'group'},
    {header : '제조사',key:'made_cmp_info_nm'},
    {header : '매입처',key:'buy_cmp_info_nm'},
    {header : '상품 1단계' ,  key : 'class_nm1'},
    {header : '상품 2단계' ,  key : 'class_nm2'},
    {header : '상품 3단계' ,  key : 'class_nm3'},
    {header : '매출금액(원)' ,key:'outcome_sum'},
    {header : '매입금액(원)' , key:'income_sum'},
    {header : 'Gross Margin' , key:'gm_amt'},
    {header : 'GM(%)' , key:'gm_amt_per'},
    {header : '매입세금계산서 발행일' ,key:'tax_sale_dt'},
    {header : '매입여부' ,key:'tax_sale_yn'},
    {header : '지급일' ,key:'pay_dt'},
    {header : '지급여부' ,key:'pay_yn'},
  ];

  if(state.gpumodelYn){
    header = [
      {header : '매입매출 그룹', key:'group'},
      {header : '제조사',key:'made_cmp_info_nm'},
      {header : '매입처',key:'buy_cmp_info_nm'},
      {header : '상품 1단계' ,  key : 'class_nm1'},
      {header : '상품 2단계' ,  key : 'class_nm2'},
      {header : '상품 3단계' ,  key : 'class_nm3'},
      {header : 'GPU Model' , key:'gpu_model_nm'},
      {header : 'GPU 수량' , key:'gpu_model_qty'},
      {header : '매출금액(원)' ,key:'outcome_sum'},
      {header : '매입금액(원)' , key:'income_sum'},
      {header : 'Gross Margin' , key:'gm_amt'},
      {header : 'GM(%)' , key:'gm_amt_per'},
      {header : '매입세금계산서 발행일' ,key:'tax_sale_dt'},
      {header : '매입여부' ,key:'tax_sale_yn'},
      {header : '지급일' ,key:'pay_dt'},
      {header : '지급여부' ,key:'pay_yn'},
    ];
  }
  let headerProps = header.map((item)=>{
    return item.key
  })
  excelManageRef.value.excelDownload(fileNm,header,inoutList,headerProps)
}
const getList2 = async () => {
  let params = {
    rev_id: state.prodRevId, // 리비전 ID 필수값
  };
  try {
    const res = await depthProdList(params)
    state.depthProdList = [...res.rtn]
    state.gpu_model_prod_list = res.rtn.filter(r=> r.gpu_model_yn ==='Y')
    const hasAnyGpuModel = state.inoutRowData.some(item => 
        state.gpu_model_prod_list.some(gpu => gpu.class_Id === item.prod_class_id)
    );
    state.gpumodelYn = hasAnyGpuModel;
    state.inoutGridColumn.forEach(column => {
      if (column.field === 'gpu_model_nm' || column.field === 'gpu_model_qty') {
          column.visible = hasAnyGpuModel;
      }
    });
    return [...res.rtn]
  } catch (err) {
    console.error(err)
  } finally {

  }
};

const downTemplateOpty = async () => {
  if(confirm('템플릿을 다운 받으시겠습니까?')){
    let optyheader = [ //중복된 값의 처리는 단일 값으로 처리한다. 
      //영업기회 템플릿
      [ //{ header: "No.", field: "index"},
        //{ header: "영업기회 ID", field: "sales_id"}, -> 자동으로 처리
        { header: "End User", field: "end_user_cmp_info_seq"},
        { header: "매출처", field: "sales_cmp_info_seq"},

        { header: "영업기회명", field: "sales_nm"},
    
        { header: "담당자1", field: "manager1"},
        { header: "담당자2", field: "manager2"},

        { header: "Bridge(B) Risk(R)", field: "bnr_cd"},
        { header: "stage", field: "stage_cd"},
        { header: "우선협상자 선정일(Won Date)", field: "won_dt"},
        { header: "PO 발행일(Close Date)", field: "po_dt"},

        { header: "매출세금계산서발행일", field: "tax_dt"},
        { header: "발행여부", field: "tax_yn"},
        { header: "수금일", field: "collect_dt"},
        { header: "수금여부", field: "collect_yn"},

        //{ header: "최초 등록일", field: "fmt_reg_dt"}, -> 자동으로 처리
        { header: "고객PO#", field: "custom_po"},
        { header: "메모", field: "memo"},

        { header: "상품(납품)정보", field: "prd_info"},
        { header: "납품완료일", field: "dlv_dt"},
        { header: "PSP 지정여부", field: "psp_yn"},
        { header: "검수완료일", field: "isp_dt"},

        { header: "계약만료일", field: "w_end_dt"},
        // { header: "aging", field: "aging"}, -> 자동으로 처리
        
        //총 매출금액, 총 매입금액, GM Amount, GM%, 메모 ->5개 필드 자동으로 처리

        { header: "제조사", field: "made_cmp_info_seq"}, 
        { header: "매입처", field: "buy_cmp_info_seq"}, 
        { header: "상품", field: "prod_class_id"},
        { header: "GPU 모델", field: "gpu_model_nm"}, 
        { header: "GPU 모델 수량", field: "gpu_model_qty"},
        { header: "매출금액", field: "outcome_sum"},  
        { header: "매입금액", field: "income_sum"},
        { header: "매입세금계산서 발행일", field: "tax_sale_dt"},
        { header: "매입여부", field: "tax_sale_yn"},
        { header: "지급일", field: "pay_dt"},
        { header: "지급여부", field: "pay_yn"}
      ],
      //담당자
      [{ header: "회사명", field: "cmp_nm"},
        { header: "사업부명", field: "cmp_dvsn_nm"},
        { header: "이름", field: "mngr_nm"},
        { header: "사업자번호", field: "business_no"},
        { header: "직급", field: "postion"},
        { header: "부서", field: "depart_nm"},
        { header: "휴대폰번호", field: "mobile"},
        { header: "이메일", field: "email"}],
      //Stage
      [{header : '상세코드',field:'cd_id'},
      {header : '코드명',field:'cd_nm'}],
      //Bridge(B),Risk(R)
      [{header : '상세코드',field:'cd_id'},
      {header : '코드명',field:'cd_nm'}],
      //회사분류
      [{header : '회사관리번호',field:'cmp_info_seq'},
      {header : '회사명',field:'cmp_nm'},
      {header : '부서명',field:'cmp_dvsn_nm'},
      {header : '대표자',field:'ceo_nm'}],
      //상품분류
      [{header : '상품코드',field:'class_Id'},
      {header : '상품명',field:'class_nm'},
      {header : 'GPU 모델',field:'gpu_model_yn'},
      {header : '계약만료 필수입력대상(Y: 계약만료일입력 필수 대상 , N: 계약만료일입력 필수 미대상 , A:계약만료일 필수 입력대상이지만, 기간제한 없음)',field:'class_nm'}],
      //GPU 모델
      [{header : '상세코드',field:'cd_id'},
      {header : '코드명',field:'cd_nm'}],
    ]
    
    try{
      setIsLoading(true)
      const mngRes = await mngList({page_count : 1,unit_count : 999999})
      const codeRes = await codeGrpDtlList({cd_gr : 'STG_CD'})
      const codeRes2 = await codeGrpDtlList({cd_gr : 'BNR_CD'})
      const compRes = await compList({page_count : 1,unit_count : 999999})
      const getList2 = await depthProdList({rev_id: state.prodRevId})
      const codeRes3 = await codeGrpDtlList({cd_gr : 'GPU_MODEL_CD'})
      //샘플데이터
      let dataList = 
        [{ 
          //index: '1',
          end_user_cmp_info_seq: 'CP-0000000334', //end_user_cmp_nm
          sales_cmp_info_seq: 'CP-0000002178', //sales_cmp_nm
          sales_nm: '테스트입니다.',
          manager1: '테스트',
          manager2: '테스트',
          bnr_cd: 'BNR01', // bnr_nm
          stage_cd: 'STG01', //stage_nm
          won_dt: '20250325', //fmt_won_dt
          po_dt: '20250325', // fmt_po_dt
          tax_dt: '20250325', //fmt_tax_dt
          tax_yn: 'Y', 
          collect_dt: '20250325', //fmt_collect_dt
          collect_yn : 'Y',
          custom_po : '3',
          memo : '테스트',
          prd_info : '테스트',
          dlv_dt : '20250325',
          psp_yn : 'Y',
          isp_dt : '20250325',
          w_end_dt : '',

          made_cmp_info_seq : 'CP-0000000334',//회사분류 샘플데이터 
          buy_cmp_info_seq : 'CP-0000000334',
          prod_class_id : 'A001A003A003', //prod_class_nm
          gpu_model_nm: '',
          gpu_model_qty:'',
          outcome_sum : '10000',
          income_sum : '10000',
          tax_sale_dt : '20250325', //fmt_tax_sale_dt
          tax_sale_yn : 'Y',
          pay_dt : '20250325',
          pay_yn :  'Y'
        }]

      const dataBySheet = {
        "영업기회 템플릿": dataList ,
        "담당자": mngRes.rtn,
        "Stage": codeRes.rtn,
        "Bridge(B),Risk(R)":codeRes2.rtn,
        "회사분류": compRes.rtn,
        '상품분류': getList2.rtn,
        "GPU 모델": codeRes3.rtn,
      };
      const headerProps = 
        // "index",
        {"영업기회 템플릿": ["end_user_cmp_info_seq","sales_cmp_info_seq","sales_nm","manager1", "manager2", "bnr_cd", "stage_cd"
                          ,"won_dt","po_dt","tax_dt","tax_yn","collect_dt","collect_yn","custom_po","memo"
                          ,"prd_info","dlv_dt","psp_yn","isp_dt","w_end_dt"
                          ,"made_cmp_info_seq","buy_cmp_info_seq","prod_class_id"
                          ,"gpu_model_nm","gpu_model_qty"
                          ,"outcome_sum","income_sum","tax_sale_dt","tax_sale_yn","pay_dt","pay_yn"]
        ,"담당자": ["cmp_nm","cmp_dvsn_nm","mngr_nm","business_no","postion","depart_nm","mobile","email"]
        ,"Stage": ["cd_id","cd_nm"]
        ,"Bridge(B),Risk(R)": ["cd_id","cd_nm"]
        ,"회사분류": ['cmp_info_seq','cmp_nm','cmp_dvsn_nm','ceo_nm']
        ,'상품분류':['class_Id','class_nm','gpu_model_yn','applicable_yn']
        ,"GPU 모델": ["cd_id","cd_nm"]
      }
        //상품분류
      excelTempManageRef.value.excelOptyDownload(optyheader,dataBySheet,headerProps)

    }catch(e){
      console.log(e)
    }finally{
      setIsLoading(false)
    }
    
  }
}

const selectTemplateUploadFile = () => {
  excelTempManageRef.value.selectUploadFile()
}
const saveExcelData = async(excelData) => {

  try{
    setIsLoading(true)
    const optyData = excelData.sheets[0]
    let res = null
    let result
    if(optyData){
      result = await checkExcelData2(optyData)
    }

    if(result){
      res = await optyExcelUpload({templateSalesOptyListVO:state.excelData})
      if(res.code !== '0000') throw new Error() 
      alert(`${state.excelData.length}건 완료했습니다.`)
      routerCmn.routerPush('/sr/MSR_SO_002')
    }
    }catch(err){
      if(!err.toString().includes('0005')){
        alert('등록에 실패했습니다.')
      }
      console.log(err)
    } finally {
      setIsLoading(false)
    }
}


const checkExcelData = async (excelData) => {
  let result  = false;
    try{
    const incorrectCol = {
      nullCell : false,
      nanCol : false,
      prodIncorrect : false, 
      notDateFormat : false,
      dateConditionTax : false,
      dateConditionTaxSale : false,
      notYn : false,
      managerLength : false,
      dateConditionPo : false,
      noRisk : false,
      noBridge : false
    }
    let incorrectIdx = null
    let excelList = []
    let akey;
    let endUserYN;
    excelData.some((item,index)=>{
      let incoreect = false
      item.index = state.inoutMaxIndex
      state.inoutMaxIndex += 1 
      state.excelTemplateHeaderKey.some((key)=>{
        if(item[key] || (key.includes('_sum') && item[key] === 0)){
          //매입,매출 금액 숫자 데이터인지 체크
          if(key.includes('_sum')){
            item[key] =  typeof item[key] === 'string' ?  item[key].replaceAll(',','') : item[key]
            incoreect = isNaN(item[key])
            if(isNaN(item[key])){
              incorrectCol.nanCol = true
              akey = key
            }
          }
          //상품 3단계이상 넣기
          if(key === 'prod_class_id'){
            if(item[key]?.length < 12){
              incoreect = true
              incorrectCol.prodIncorrect = true
              akey = key
            }
          }
          //엑셀 날짜 데이터들은 8자리수로 맞추기 
          if(key.includes('_dt')&&key !== 'w_end_dt'){
            
            if(item[key].toString().length > 8 || item[key].toString().length < 8){
              incoreect = true
              incorrectCol.notDateFormat = true
              akey = key
            }
          }

          //여부 컬럼에 y,n 값 외 입력됐을 경우 막기
          if(key === 'tax_yn' || key === 'collect_yn' ||key === 'tax_sale_yn' ||key === 'pay_yn'){
            if(item[key]){
              if(item[key] !== 'y' && item[key] !== 'Y' && item[key] !== 'n' && item[key] !== 'N'){
                incorrectCol.notYn = true
                incoreect = true
                akey = key
              }else{
                item[key] = item[key] ? item[key].toUpperCase() : item[key]
                akey = key
              }
            }
          }

          //담당자 10자 이하만 입력가능 
          if(key === 'manager1' || key === 'manager2'){
            if(item[key].length > 10){
              incorrectCol.managerLength = true
              incoreect = true
              akey = key
            }
          }

          //Bridge & Risk 선수 조건
          if(key ==='bnr_cd'){
            if(item['bnr_cd'] == 'BNR03'){
              if(item['stage_cd'] !=='STG03'&& item['stage_cd'] !=='STG06'&& item['stage_cd'] !=='STG07'){
                incorrectCol.noRisk = true
                incoreect = true
                akey = key
              }
            }else if(item['bnr_cd'] == 'BNR02'){
              if(item['stage_cd'] !=='STG02' && item['stage_cd'] !=='STG06' && item['stage_cd'] !=='STG07'){
                incorrectCol.noBridge = true
                incoreect = true
                akey = key
              }
            }
          }


          if(key ='end_user_cmp_info_seq'){
            endUserYN = item[key] 
          }
            
        }else{
          if(endUserYN){
            if(state.optyKey.includes(key)){               
              
                incoreect = true
                incorrectCol.nullCell = true
                akey = key
            }else if(state.optykey2.includes(key)){
              incoreect = true
              incorrectCol.nullCell = true
              akey = key
            }
          }else if(state.optykey2.includes(key)){
              incoreect = true
              incorrectCol.nullCell = true
              akey = key
          }else if(state.optykey3.includes(key)){
            if(state.mkCmpSeq != item['buy_cmp_info_seq']){
              incoreect = true
              incorrectCol.nullCell = true
              akey = key
            }else{
              item['income_sum'] = 0
              item['tax_sale_dt'] = null
              item['tax_sale_yn'] = null
              item['pay_dt'] = null
              item['pay_yn'] = null
            }
          }
          endUserYN = ""
        }
        return incoreect
      })

      if(!incorrectCol.notDateFormat){
        //매출세금계산서 발행일 <= 수금일 조건
        if(item['tax_dt'] && item['collect_dt']){
          if(item['tax_dt'] > item['collect_dt']) {
            incoreect = true
            incorrectCol.dateConditionTax = true
          }
        }
        // //매입세금계산서 발행일 <= 지급일 조건
        // if(item['tax_sale_dt'] && item['pay_dt']){
        //   if(item['tax_sale_dt'] > item['pay_dt']) {
        //     incoreect = true
        //     incorrectCol.dateConditionTaxSale = true
        //   }
        // }

        if(item['won_dt'] && item['po_dt']){
          if(item['po_dt'] < item['won_dt']) {
            incoreect = true
            incorrectCol.dateConditionPo = true
          }
        }

        if(item['gpu_model_nm'] && item['gpu_model_qty']){
          if(checkGPUModel(item['prod_class_id'])) {
            incoreect = true
            incorrectCol.dateConditionPo = true
          }
        }

      }


      if(!incoreect) {
        excelList.push(item)
      }else{
        incorrectIdx = index
      }
      
      return incoreect
    })

    let notUpload = false
    for(let flag in incorrectCol){
      if(incorrectCol[flag]){
        notUpload = incorrectCol[flag]
        break;
      }
    }
    // const prodRes = await searchProdList()
    // const prodList = [...prodRes.rtn]
    // const prodRevId = prodList[0].rev_id
    if(!notUpload){
      state.excelData = []
      for(let inoutData of excelList){
        inoutData['ss_user_id'] = userStore.user.employeeId;
        inoutData['sales_ceo'] = userStore.user.userNm ? userStore.user.userNm : '';
        inoutData['tb_id'] =  'sales';
        let outcome_sum_val = Number(inoutData.outcome_sum)
        let income_sum_val = Number(inoutData.income_sum)

        let gm_amt =  outcome_sum_val - income_sum_val 
        inoutData['gm_amt'] =  isNaN(Number(gm_amt)) ? 0 : gm_amt
        
        let gm_amt_per = (gm_amt / outcome_sum_val * 100).toFixed(1)
        inoutData['gm_amt_per'] =  isFinite(Number(gm_amt_per)) ? Number(gm_amt_per): 0 

        inoutData['cap_seq'] = 0;
        inoutData['ngt_date'] = '';
        inoutData['bkmark_yn'] = 'N';
        inoutData['prod_rev_id'] =  state.prodRevId;
        inoutData['tmp_yn'] =  'N';
        inoutData['w_alarm_yn'] =  'N';
        state.excelData.push(inoutData);
        result = true
      }
    }else{
      let msg = ''
      Object.keys(incorrectCol).some((key)=>{
        switch(key){
          case 'nullCell' :
            if(incorrectCol[key]) msg = '필수값이 누락된 셀이 있습니다.\n'
          break;
          case 'prodIncorrect' :
            if(incorrectCol[key]) msg = '3단계가 아닌 상품분류체계가 있습니다.\n'
          break;
          case 'nanCol' :
            if(incorrectCol[key]) msg = '숫자 형식이 아닌 데이터가 있습니다.\n'
          break;
          case 'notDateFormat' :
            if(incorrectCol[key]) msg = '날짜 형식이 아닌 셀이 있습니다.\n'
          break;
          case 'dateConditionTax' :
            if(incorrectCol[key]) msg = '수금일이 매출세금계산서 발행일보다 빠릅니다.\n'
          break;
          case 'dateConditionTaxSale' :
            if(incorrectCol[key]) msg = '지급일이 매입세금계산서 발행일보다 빠릅니다.\n'
          break;
          case 'notYn' :
            if(incorrectCol[key]) msg = '여부관련 값에 맞지 않는 값이 있습니다.\n'
          break;
          case 'managerLength' : 
            if(incorrectCol[key]) msg = '담당자는 10자 이하로 입력 가능합니다.\n'
          break;
          case 'dateConditionPo' : 
            if(incorrectCol[key]) msg = 'po발행일이 우선협상자 선정일보다 빠릅니다.\n'
          break;
          case 'noRisk' :
            if(incorrectCol[key]) msg = 'Bridge(B),Risk(R)의 Risk는 Stage가 Commit(Lost,Omit)일때 가능합니다.\n'
          break;
           case 'noBridge' :
            if(incorrectCol[key]) msg = 'Bridge(B),Risk(R)의 Bridge는 Stage가 Upside(Lost,Omit)일때 가능합니다.\n'
          break;
        }
      })
      let koreaOpty = ""
      state.koreaOpty.forEach((item)=>{
        if(item["key"] === akey){
          koreaOpty = item["name"]
        }
      })
      
      //여기서 컬럼이 어떤 이름인지 표출해주는 로직을 추가? 
      alert(`${incorrectIdx+2}번째 행에 ${koreaOpty}\n${msg}확인 후 다시 업로드해주세요.`)
    }
  }catch(e){
    alert('엑셀 업로드에 실패했습니다.파일을 확인 후 다시 업로드해주세요.')
  }
  return result
}

const checkExcelData2 = async (excelData) => {
  let result = false;
  let globalIncorrectIdx = null; 
  let globalIncorrectColKey = null; 
  let globalIncorrectMsg = ''; 
  const codeRes3 = await codeGrpDtlList({cd_gr : 'GPU_MODEL_CD'})

  try {
    const incorrectColTypes = { 
      nullCell: false, nanCol: false, prodIncorrect: false,
      notDateFormat: false, dateConditionTax: false, dateConditionTaxSale: false,
      notYn: false, managerLength: false, dateConditionPo: false,
      noRisk: false, noBridge: false, dateConditionProd: false
    };

    let excelListForUpload = [];
    let groupedOpportunities = [];
    let currentOpportunity = null; 

    for (let i = 0; i < excelData.length; i++) {
        const item = excelData[i];
        const isNewOpportunity = !!item['end_user_cmp_info_seq'];
        item.originalIndex = i;

        if (isNewOpportunity) {
            if (currentOpportunity) {
                groupedOpportunities.push(currentOpportunity);
            }
            currentOpportunity = {
                details: { 
                    tax_dt: item['tax_dt'] || null,
                    tax_yn: item['tax_yn'] ? item['tax_yn'].toUpperCase() : null,
                    stage_cd: item['stage_cd'] || null, 
                    isp_dt: item['isp_dt'] || null,
                    w_end_dt: item['w_end_dt'] || null,
                    manager1: item['manager1'] || null,
                    manager2: item['manager2'] || null,
                    bnr_cd: item['bnr_cd'] || null,
                    buy_cmp_info_seq: item['buy_cmp_info_seq'] || null 
                },
                products: [] 
            };
        } else {
            if (!currentOpportunity) {
                globalIncorrectIdx = item.originalIndex;
                globalIncorrectColKey = 'end_user_cmp_info_seq';
                globalIncorrectMsg = `엑셀의 첫 번째 행에 영업기회 필수 정보(End User)가 누락되었습니다.`;
                incorrectColTypes.nullCell = true;
                throw new Error("Initial data structure error"); 
            }

        }

        currentOpportunity.products.push(item);
    }

    if (currentOpportunity) {
        groupedOpportunities.push(currentOpportunity);
    }

    const isAnyOpportunityIncorrect = groupedOpportunities.some((opp, oppIndex) => {

        let incoreectInCurrentOpp = false;
        let firstErrorInOppItem = null; 
        let firstErrorInOppColKey = null;
        let firstErrorInOppMsg = null;


        for (const productItem of opp.products) {
            const item = productItem;
            let currentItemColKeyForError = null;


            for (const key of state.excelTemplateHeaderKey) {
                const value = item[key]; 

                if (key === 'end_user_cmp_info_seq') { continue; } 

                if (value || (key.includes('_sum') && value === 0)) {

                    if (key.includes('_sum')) {
                        item[key] = typeof value === 'string' ? value.replaceAll(',', '') : value;
                        if (isNaN(item[key])) { 
                          incorrectColTypes.nanCol = true; 
                          incoreectInCurrentOpp = true; 
                          firstErrorInOppColKey = key; 
                          firstErrorInOppItem = item; 
                          break;
                         }
                    }

                    if (key === 'prod_class_id') {
                      if (value?.length < 12) {
                          incorrectColTypes.prodIncorrect = true; 
                          incoreectInCurrentOpp = true; 
                          firstErrorInOppColKey = key; 
                          firstErrorInOppItem = item; 
                          break; 
                      } else if (checkGPUModel(value)) {
                          if (!item['gpu_model_nm']) {
                              globalIncorrectMsg = 'GPU 모델 코드를입력해 주세요.';
                              incoreectInCurrentOpp = true;
                              firstErrorInOppColKey = 'gpu_model_nm';
                              firstErrorInOppItem = item;
                              break;
                          }else if(!item['gpu_model_qty']){ 
                              globalIncorrectMsg = 'GPU 모델 수량을입력해 주세요.';
                              incoreectInCurrentOpp = true;
                              firstErrorInOppColKey = 'gpu_model_qty';
                              firstErrorInOppItem = item;
                              break;  
                          }else if(item['gpu_model_nm']){
                            const gpuCodes = codeRes3.rtn;
                            const isValidGpuModel = gpuCodes.some(codeItem => codeItem.cd_id === item['gpu_model_nm']);
                            
                            if (!isValidGpuModel) {
                                incoreectInCurrentOpp = true;
                                firstErrorInOppColKey = 'gpu_model_nm';
                                firstErrorInOppItem = item;
                                globalIncorrectMsg = 'GPU 모델 코드가 유효하지 않습니다. 올바른 코드를 입력해주세요.';
                                break;
                            }
                          }else if(item['gpu_model_qty']){
                            item['gpu_model_qty'] = typeof value === 'string' ? value.replaceAll(',', '') : value;
                            if (isNaN(item['gpu_model_qty'])) { 
                              incorrectColTypes.nanCol = true; 
                              incoreectInCurrentOpp = true; 
                              firstErrorInOppColKey = key; 
                              firstErrorInOppItem = item; 
                              break;
                            }
                          }
                      } else {
                          item['gpu_model_nm'] = null;
                          item['gpu_model_qty'] = null;
                      }
                    }

                    if (key.includes('_dt') && key !== 'w_end_dt') {
                        if (String(value)?.length !== 8) { 
                            incorrectColTypes.notDateFormat = true; 
                            incoreectInCurrentOpp = true; 
                            firstErrorInOppColKey = key; 
                            firstErrorInOppItem = item; break;
                        }
                    }

                    if (key === 'tax_yn' || key === 'collect_yn' || key === 'tax_sale_yn' || key === 'pay_yn') {
                        if (value) {
                            const upperCaseVal = String(value).toUpperCase();
                            if (upperCaseVal !== 'Y' && upperCaseVal !== 'N') {
                                incorrectColTypes.notYn = true; 
                                incoreectInCurrentOpp = true; 
                                firstErrorInOppColKey = key; 
                                firstErrorInOppItem = item; break;
                            } else { item[key] = upperCaseVal; }
                        }
                    }

                    if (key === 'manager1' || key === 'manager2') {
                        if (String(value)?.length > 10) { 
                            incorrectColTypes.managerLength = true; 
                            incoreectInCurrentOpp = true; 
                            firstErrorInOppColKey = key; 
                            firstErrorInOppItem = item; 
                            break;
                        }
                    }

                    if (key === 'bnr_cd') {
                        if (value === 'BNR03') {
                            if (opp.details.stage_cd !== 'STG03' && opp.details.stage_cd !== 'STG06' && opp.details.stage_cd !== 'STG07') {
                                incorrectColTypes.noRisk = true; 
                                incoreectInCurrentOpp = true; 
                                firstErrorInOppColKey = key; 
                                firstErrorInOppItem = item; 
                                break;
                            }
                        } else if (value === 'BNR02') {
                            if (opp.details.stage_cd !== 'STG02' && opp.details.stage_cd !== 'STG06' && opp.details.stage_cd !== 'STG07') {
                                incorrectColTypes.noBridge = true; 
                                incoreectInCurrentOpp = true; 
                                firstErrorInOppColKey = key; 
                                firstErrorInOppItem = item; 
                                break;
                            }
                        }
                    }
                } else { 

                    const isNewOppAtThisItem = (item.originalIndex === opp.products[0].originalIndex); 
                    const isOptyKeyMandatory = isNewOppAtThisItem ? state.optyKey.includes(key) : state.optykey2.includes(key);
                    const isOptyKey3Mandatory = state.optykey3.includes(key);

                    if (isOptyKeyMandatory) {
                        incorrectColTypes.nullCell = true; 
                        incoreectInCurrentOpp = true; 
                        firstErrorInOppColKey = key; 
                        firstErrorInOppItem = item; 
                        break;
                    } else if (isOptyKey3Mandatory) {
                      
                        if (state.mkCmpSeq != opp.details.buy_cmp_info_seq) { 
                            incorrectColTypes.nullCell = true; 
                            incoreectInCurrentOpp = true; 
                            firstErrorInOppColKey = key; 
                            firstErrorInOppItem = item; 
                            break;
                        } else { 
                            item['income_sum'] = 0; 
                            item['tax_sale_dt'] = null; 
                            item['tax_sale_yn'] = null;
                            item['pay_dt'] = null; 
                            item['pay_yn'] = null;
                        }
                    }
                }
            }
            if (incoreectInCurrentOpp) {
              globalIncorrectIdx = firstErrorInOppItem.originalIndex;
              globalIncorrectColKey = firstErrorInOppColKey;
              return true; 
            }
            
            if (!incorrectColTypes.notDateFormat) { 
                // if (item['tax_sale_dt'] && item['pay_dt']) {
                //     const taxSaleDt = new Date(String(item['tax_sale_dt']).replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'));
                //     const payDt = new Date(String(item['pay_dt']).replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'));
                //     if (isNaN(taxSaleDt.getTime()) || isNaN(payDt.getTime()) || taxSaleDt > payDt) {
                //         incoreectInCurrentOpp = true; 
                //         incorrectColTypes.dateConditionTaxSale = true; 
                //         firstErrorInOppColKey = 'pay_dt'; 
                //         firstErrorInOppItem = item; break;
                //     }
                // }

                if (item['won_dt'] && item['po_dt']) {
                    const wonDt = new Date(String(item['won_dt']).replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'));
                    const poDt = new Date(String(item['po_dt']).replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'));
                    if (isNaN(wonDt.getTime()) || isNaN(poDt.getTime()) || poDt < wonDt) {
                        incoreectInCurrentOpp = true; 
                        incorrectColTypes.dateConditionPo = true; 
                        firstErrorInOppColKey = 'po_dt'; 
                        firstErrorInOppItem = item; break;
                    }
                }
            }
        } 
        
        if (incoreectInCurrentOpp) {
            globalIncorrectIdx = firstErrorInOppItem.originalIndex;
            globalIncorrectColKey = firstErrorInOppColKey;
            return true;
        }



        let applicableYnForThisOpportunity = { isApplicable: true, productName: null, hasAMatch: false };
        if (state.depthProdList && opp.products.length > 0) {
            const yListForCheck = state.depthProdList.filter(r => r.applicable_yn == 'Y' || r.applicable_yn == 'A');

            applicableYnForThisOpportunity = checkApplicableLists(yListForCheck, opp.products); 
        }


        if (opp.details.tax_dt &&
            opp.details.tax_yn === 'Y' &&
            (opp.details.stage_cd && (opp.details.stage_cd.includes('STG03') ||
             opp.details.stage_cd.includes('STG04') ||
             opp.details.stage_cd.includes('STG05'))) &&
            !applicableYnForThisOpportunity.isApplicable
        ) {

            if (!opp.details.isp_dt && !opp.details.w_end_dt) {
              incoreectInCurrentOpp = true; incorrectColTypes.dateConditionProd = true;
              firstErrorInOppColKey = '날짜 조건'; 
              firstErrorInOppItem = opp.products[0];
              globalIncorrectMsg = `${applicableYnForThisOpportunity.productName} 상품이 입력된 경우 검수완료일과 계약만료일은 필수로 입력해야 합니다.`;
            } else if (!opp.details.isp_dt && opp.details.w_end_dt) {
              incoreectInCurrentOpp = true; 
              incorrectColTypes.dateConditionProd = true;
              firstErrorInOppColKey = '날짜 조건'; firstErrorInOppItem = opp.products[0];
              globalIncorrectMsg = `${applicableYnForThisOpportunity.productName} 상품이 입력된 경우 검수완료일은 필수로 입력해야 합니다.`;
            } else if (opp.details.isp_dt && !opp.details.w_end_dt) {
              incoreectInCurrentOpp = true; 
              incorrectColTypes.dateConditionProd = true;
              firstErrorInOppColKey = '날짜 조건';
               firstErrorInOppItem = opp.products[0];
              globalIncorrectMsg = `${applicableYnForThisOpportunity.productName} 상품이 입력된 경우 계약만료일은 필수로 입력해야 합니다.`;
            } else {

              if (applicableYnForThisOpportunity.hasAMatch) {

              } else {

                let hasDateViolationForThisCheck = false;
                let tempDateWarnMsg = '';

                if (opp.details.tax_dt && opp.details.isp_dt) {
                  const diffIspDt = getDaysDiff(opp.details.tax_dt, opp.details.isp_dt);
                  if (diffIspDt > 31 || isNaN(diffIspDt)) {
                    hasDateViolationForThisCheck = true;
                    tempDateWarnMsg = `납세일자(${opp.details.tax_dt})와 검수완료일(${opp.details.isp_dt})의 날짜 차이가 ±31일 범위를 벗어납니다.`;
                  }
                }

                if (opp.details.tax_dt && opp.details.w_end_dt) {
                  const diffWEndDt = getDaysDiff(opp.details.tax_dt, opp.details.w_end_dt);
                  if (diffWEndDt > 31 || isNaN(diffWEndDt)) {
                    hasDateViolationForThisCheck = true;
                    tempDateWarnMsg = `매출세금계산서일자(${opp.details.tax_dt})와 계약만료일(${opp.details.w_end_dt})의 날짜 차이가 ±31일 범위를 벗어납니다.`;
                  }
                }

                if (hasDateViolationForThisCheck) {
                  incoreectInCurrentOpp = true; 
                  incorrectColTypes.dateConditionProd = true;
                  firstErrorInOppColKey = '날짜 조건'; 
                  firstErrorInOppItem = opp.products[0];
                  globalIncorrectMsg = `${applicableYnForThisOpportunity.productName} 상품의 날짜 비교 오류: ${tempDateWarnMsg}.`;
                }
              }
            }
        }

        if (incoreectInCurrentOpp) {
            globalIncorrectIdx = firstErrorInOppItem.originalIndex;
            globalIncorrectColKey = firstErrorInOppColKey;
            return true;
        }
        
        excelListForUpload.push(...opp.products);
        return false;
    });


    let notUpload = isAnyOpportunityIncorrect;

    if (!notUpload) {
      state.excelData = [];
      for (let inoutData of excelListForUpload) {
        inoutData['ss_user_id'] = userStore.user.employeeId;
        inoutData['sales_ceo'] = userStore.user.userNm ? userStore.user.userNm : '';
        inoutData['tb_id'] = 'sales';
        let outcome_sum_val = Number(inoutData.outcome_sum);
        let income_sum_val = Number(inoutData.income_sum);

        let gm_amt = outcome_sum_val - income_sum_val;
        inoutData['gm_amt'] = isNaN(Number(gm_amt)) ? 0 : gm_amt;

        let gm_amt_per = (gm_amt / outcome_sum_val * 100).toFixed(1);
        inoutData['gm_amt_per'] = isFinite(Number(gm_amt_per)) ? Number(gm_amt_per) : 0;

        inoutData['cap_seq'] = 0;
        inoutData['ngt_date'] = '';
        inoutData['bkmark_yn'] = 'N';
        inoutData['prod_rev_id'] = state.prodRevId;
        inoutData['tmp_yn'] = 'N';
        inoutData['w_alarm_yn'] = 'N';
        state.excelData.push(inoutData);
      }
      result = true;
    } else {
      let msg = globalIncorrectMsg;
      if (!msg) {
          Object.keys(incorrectColTypes).some((key) => {
              if (incorrectColTypes[key]) {
                  switch (key) {
                      case 'nullCell': msg = '필수값이 누락된 셀이 있습니다.\n'; break;
                      case 'prodIncorrect': msg = '3단계가 아닌 상품분류체계가 있습니다.\n'; break;
                      case 'nanCol': msg = '숫자 형식이 아닌 데이터가 있습니다.\n'; break;
                      case 'notDateFormat': msg = '날짜 형식이 아닌 셀이 있습니다.\n'; break;
                      case 'dateConditionTax': msg = '수금일이 매출세금계산서 발행일보다 빠릅니다.\n'; break;
                      case 'dateConditionTaxSale': msg = '지급일이 매입세금계산서 발행일보다 빠릅니다.\n'; break;
                      case 'notYn': msg = '여부관련 값에 맞지 않는 값이 있습니다.\n'; break;
                      case 'managerLength': msg = '담당자는 10자 이하로 입력 가능합니다.\n'; break;
                      case 'dateConditionPo': msg = 'po발행일이 우선협상자 선정일보다 빠릅니다.\n'; break;
                      case 'noRisk': msg = 'Bridge(B),Risk(R)의 Risk는 Stage가 Commit(Lost,Omit)일때 가능합니다.\n'; break;
                      case 'noBridge': msg = 'Bridge(B),Risk(R)의 Bridge는 Stage가 Upside(Lost,Omit)일때 가능합니다.\n'; break;
                      case 'notGpuModel': msg = 'GPU Model값이 해당하지 않는 상품에 입력되었습니다.\n'; break;
                      case 'prodgpuModel': msg = '해당상품은 GPU모델과 수량이 필수로 입력되어야 합니다.\n'; break;
                  }
                  return true;
              }
              return false;
          });
      }

      let koreaOptyName = "";
      if (globalIncorrectColKey) {
          state.koreaOpty.forEach((item) => {
              if (item["key"] === globalIncorrectColKey) {
                  koreaOptyName = item["name"];
              }
          });
      }

      alert(`${globalIncorrectIdx + 2}번째 행에 ${koreaOptyName}\n${msg}확인 후 다시 업로드해주세요.`);
    }
  } catch (e) {
    console.error("엑셀 업로드 유효성 검사 중 오류 발생:", e);
    if (globalIncorrectMsg && globalIncorrectIdx !== null) {
        alert(`${globalIncorrectIdx + 2}번째 행에\n${globalIncorrectMsg}확인 후 다시 업로드해주세요.`);
    } else {
        alert('엑셀 업로드 중 치명적인 오류가 발생했습니다. 파일을 확인 후 다시 업로드해주세요.');
    }
  }
  return result;
};



function downTemplateInout(){
  if(confirm('템플릿을 다운 받으시겠습니까?')){
    let header = [
      {header : '제조사',field:'made_cmp_info_nm'},
      {header : '매입처',field:'buy_cmp_info_nm'},
      {header : '상품',field:'class_nm'},
      {header : '매출금액(원)',field:'outcome_sum'},
      {header : '매입금액(원)',field:'income_sum'},
      {header : '매출세금계산서 발행일(yyyy-mm-dd)',field:'tax_dt'},
      {header : '발행여부',field:'tax_yn'},
      {header : '수금일(yyyy-mm-dd)',field:'collect_dt'},
      {header : '수금여부',field:'collect_yn'},
      {header : '매입세금계산서 발행일(yyyy-mm-dd)',field:'tax_sale_dt'},
      {header : '매입여부',field:'tax_sale_yn'},
      {header : '지급일(yyyy-mm-dd)',field:'pay_dt'},
      {header : '지급여부',field:'pay_yn'},
    ]
    //샘플데이터
    let dataList = [
      { made_cmp_info_nm: 'CP-0000001013',
        buy_cmp_info_nm: 'CP-0000001001',
        class_nm: 'A001A003A001',
        outcome_sum: '10000',
        income_sum: '10000',
        tax_dt: '2024-05-08',
        tax_yn: 'Y',
        collect_dt: '2024-05-08',
        collect_yn: 'Y',
        tax_sale_dt: '2024-05-08',
        tax_sale_yn: 'Y',
        pay_dt: '2024-05-08',
        pay_yn: 'Y',
      },
    ]

    excelManageRef.value.excelDownload('매입매출 템플릿',header,dataList)
  }
}
//excelupload click
const selectUploadFile = ()=>{
    excelManageRef.value.selectUploadFile()
}

//get upload File
const getExcelData = async(excelData) =>{
  try{
    let offset = 9*60*60 * 1000;

    const cmpRes = await searchCmpList({page_count : 1,unit_count : 999999})
    const cmpList = [...cmpRes.rtn]

    const prodRes = await searchProdList()
    const prodList = [...prodRes.rtn]
    const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
    let excelList = []

    const incorrectCol = {
      nullCell : false,
      nanCol : false,
      prodIncorrect : false, 
      notDateFormat : false,
      dateConditionTax : false,
      dateConditionTaxSale : false,
      notYn : false,
      noRisk : false,
      noBridge : false
    }

    let incorrectIdx = null
    excelData[0].some((item,index)=>{
      let incoreect = false
      item.index = state.inoutMaxIndex
      state.inoutMaxIndex += 1 
      state.excelHeaderKey.some((key)=>{
        if(item[key]){

        //회사관리번호 매핑해서 이름으로 보여주기
        if(key === 'made_cmp_info' || key === 'buy_cmp_info'){
          let cmp = cmpList.find((cmp)=>cmp.cmp_info_seq === item[key])

          if(cmp){
            let cmp_nm = cmp['cmp_nm']
            item[`${key}_seq`] = item[key]
            item[`${key}_nm`] = cmp_nm
          }
        }

        //상품코드를 상품명으로 보여주기
        if(key === 'class_id'){
          if(item[key]?.length < 12){
            incoreect = true
            incorrectCol.prodIncorrect = true
          }else{
            let prodFam = common.findUperCode(item[key],prodList)
            if(prodFam.length > 0){
              item['prod_class_id'] = item[key]
              item['prod_rev_id'] = state.maxRev
              item['prod_level'] = prodFam.length
              //createInoutCol(prodFam)
              prodFam.forEach((prod,index)=>{
                item[`class_nm${index+1}`] = prod.class_nm
              })
            }
          }
        }
        //매입,매출 금액 숫자 데이터인지 체크
        if(key.includes('_sum')){
          incoreect = isNaN(Number(item[key]))
          if(isNaN(Number(item[key]))){
            incorrectCol.nanCol = true
          }
        }

        //엑셀 날짜 데이터들은 utc 기준이라 kst시간대로 +9시간 맞추기
        if(key.includes('_dt')){
          if(item[key] instanceof Date){
            item[key] = common.dateFormat(new Date(item[key].getTime() + offset))
            if (!dateFormatRegex.test(item[key])) {
              incoreect = true
              incorrectCol.notDateFormat = true
            }
          }else{
            incoreect = true
            incorrectCol.notDateFormat = true
          }
        }

        //여부 컬럼에 y,n 값 외 입력됐을 경우 막기
        if(key === 'tax_yn' || key === 'collect_yn' ||key === 'tax_sale_yn' ||key === 'pay_yn'){
          if(item[key]){
            if(item[key] !== 'y' && item[key] !== 'Y' && item[key] !== 'n' && item[key] !== 'N'){
              incorrectCol.notYn = true
              incoreect = true
            }else{
              item[key] = item[key] ? item[key].toUpperCase() : item[key]
            }
          }
        }
        }else{
          if([state.inoutKey].includes(key)){
            incoreect = true
            incorrectCol.nullCell = true
          }
          
        }
        return incoreect
      })

      // 2025-03-27
      // if(!incorrectCol.notDateFormat){
      //   //매출세금계산서 발행일 <= 수금일 조건
      //   if(item['tax_dt'] && item['collect_dt']){
      //     if(item['tax_dt'] > item['collect_dt']) {
      //       incoreect = true
      //       incorrectCol.dateConditionTax = true
      //     }
      //   }

      //   //매입세금계산서 발행일 <= 지급일 조건
      //   if(item['tax_sale_dt'] && item['pay_dt']){
      //     if(item['tax_sale_dt'] > item['pay_dt']) {
      //       incoreect = true
      //       incorrectCol.dateConditionTaxSale = true
      //     }
      //   }
      // }

      if(!incoreect) {
        excelList.push(item)
      }else{
        incorrectIdx = index
      }
      
      return incoreect
    })

    let notUpload = false
    for(let flag in incorrectCol){
      if(incorrectCol[flag]){
        notUpload = incorrectCol[flag]
        break;
      }
    }

    if(!notUpload){
      for(let inoutData of excelList){
        state.inoutRowData.push(inoutData)
      }
      alert(`${excelList.length}건 완료했습니다.`)
      alert('영업기회 저장 후에 반영 데이터입니다.\n저장하지 않을 경우 등록하신 매입매출은 저장되지 않습니다.')
      getGMandGMper();
      searchInoutList();
    }else{
      let msg = ''
      Object.keys(incorrectCol).some((key)=>{
        switch(key){
          case 'nullCell' :
            if(incorrectCol[key]) msg = '필수값이 누락된 셀이 있습니다.\n'
          break;
          case 'prodIncorrect' :
            if(incorrectCol[key]) msg = '3단계가 아닌 상품분류체계가 있습니다.\n'
          break;
          case 'nanCol' :
            if(incorrectCol[key]) msg = '숫자 형식이 아닌 데이터가 있습니다.\n'
          break;
          case 'notDateFormat' :
            if(incorrectCol[key]) msg = '날짜 형식이 아닌 셀이 있습니다.\n'
          break;
          // 2025-03-27
          // case 'dateConditionTax' :
          //   if(incorrectCol[key]) msg = '수금일이 매출세금계산서 발행일보다 빠릅니다.\n'
          // break;
          case 'dateConditionTaxSale' :
            if(incorrectCol[key]) msg = '지급일이 매입세금계산서 발행일보다 빠릅니다.\n'
          break;
          case 'notYn' :
            if(incorrectCol[key]) msg = '여부관련 값에 맞지 않는 값이 있습니다.\n'
          break;
        }
      })
      alert(`${incorrectIdx+2}번째 행에\n${msg}확인 후 다시 업로드해주세요.`)
    }

  }catch(e){
    alert('엑셀 업로드에 실패했습니다.파일을 확인 후 다시 업로드해주세요.')
  }
  
}

//숫자 콤마 형식 변환 함수
function numberFomat(number){
  return common.checkNumberComma(number)
}

function getCodeNm(val){
  if(val){
    const getCodeNNm = codeStore.getCodeNm('GPU_MODEL_CD',val)
    return getCodeNNm.cd_nm
  } 
}

//회사 리스트 조회(회사 엑셀 다운로드에 사용)
async function searchCmpList(params){
  try{
    setIsLoading(true)
    const res = await compList(params)
    return res
  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }
}

async function searchCmpExcelList(params){
  try{
    setIsLoading(true)
    const res = await compList(params)
    return res.rtn
  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }
}

async function searchProdList(){
  try{
    setIsLoading(true)
    const revRes = await getProdRevIdList()
    revRes.rtn.forEach((item)=>{
      if(item.rev_id > state.maxRev) state.maxRev = item.rev_id
    })
    const prodRes = await prodList({rev_id : state.maxRev})
    state.prodRevId = prodRes.rtn[0].rev_id
    return prodRes
  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }
}

async function getProdRevId(){
  try{
    setIsLoading(true)
    const revRes = await getProdRevIDYearList()
    if(state.inoutParams.tax_dt){
      const fs_year = state.inoutParams.tax_dt.substring(0,4)
      state.maxRev = getRevIdByYear(fs_year, revRes.rtn)

    }else{
      revRes.rtn.forEach((item)=>{
        if(item.rev_id > state.maxRev) state.maxRev = item.rev_id
      })
    }

    state.prodRevId = state.maxRev

    let params = {
      rev_id: state.prodRevId, // 리비전 ID 필수값
    };

    const res = await depthProdList(params)
    state.depthProdList = [...res.rtn]
    state.gpu_model_prod_list = res.rtn.filter(r=> r.gpu_model_yn ==='Y')
    const hasAnyGpuModel = state.inoutRowData.some(item => 
        state.gpu_model_prod_list.some(gpu => gpu.class_Id === item.prod_class_id)
    );
    state.gpumodelYn = hasAnyGpuModel;
    state.inoutGridColumn.forEach(column => {
      if (column.field === 'gpu_model_nm' || column.field === 'gpu_model_qty') {
          column.visible = hasAnyGpuModel;
      }
    });
  return [...res.rtn]
  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }
}

function getRevIdByYear(yearToFind, dataList) {
  const foundItem = dataList.find(item => {
    if (typeof item.quota_year === 'string' && item.quota_year.length > 0) {
      
        const years = item.quota_year.split(',');
        return years.includes(yearToFind);
    }
    return false;
  });
  return foundItem ? foundItem.rev_id : null;
}

async function downloadCmpExcel(){
  try{
    setIsLoading(true)
    let params = {
      page_count : 1,
      unit_count : 999999
    }
    const res = await searchCmpList(params)

    let fileNm = '회사 목록'
    let cmpList = [...res.rtn]
    let header = [
      {header : '회사명',field:'cmp_nm'},
      {header : '부서명',field:'cmp_dvsn_nm'},
      {header : '회사관리번호' ,field:'cmp_info_seq'},
    ];
    excelManageRef.value.excelDownload(fileNm,header,cmpList)
  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }
}

async function downloadProdExcel(){
try{
    setIsLoading(true)

    const prodRes = await searchProdList()

    let fileNm = '상품 목록'
    let header = [state.excelGridColumn1,[]];
    let headerProps = []

    let tmpHeaderProps = [
      "rev_id",
      "class_id",
      "enable_yn",
      
    ]
    let maxDepth = 3
    let param = {
      rev_id: prodRes.rtn[0].rev_id,
    };
    const res = await prodList(param)
    state.prodList = [...res.rtn]
    const prodDataList = [...res.rtn].map((item)=>{
      let codeFam = common.findUperCode(item.class_id,[...res.rtn]) || []
      if(codeFam.length > 0){
        codeFam.forEach((itemCode, index) =>
          item[`class_nm${index + 1}`] = itemCode.class_nm 
        )
        if(codeFam.length > maxDepth) maxDepth = codeFam.length
        return item
      }
    });

    const rootList = []

    prodDataList.filter(item => item.up_class_id === '').forEach((parentItem)=>{
      let row = {
        key: parentItem['class_id'],
        data: parentItem,
      };
      rootList.push(row);
      
    })
    rearrange(rootList)

    rootList.forEach((data)=>{
      state.excelData.push(data.data)
      if(data.children?.length > 0){
        findChildren(data.children)
      }
    })

    function findChildren(childList){
      [...childList].forEach((child)=>{
        state.excelData.push(child.data)
        if(child.children?.length > 0){
          findChildren(child.children)
        }
      })
    }

    for(var i=1; i<=maxDepth; i++){
      headerProps.push(`class_nm${i}`)
      header[1].push({header : `${i}단계`,rowspan : 1,colspan : 1})
    }
    headerProps = [...headerProps,...tmpHeaderProps]
    header[0].colspan = maxDepth


    excelManageRef.value.excelDownload(fileNm, [...header], [...state.excelData],[...headerProps])

  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }
}

//child depth 계속 생성
const rearrange = (rootList) => {
    rootList.forEach((item)=>{
      let childTree = [];
      state.prodList.forEach((i) => {
        if (i.up_class_id === item.key) {
          let row = {
            key: i.class_id,
            data: i,
          };
          childTree.push(row);
        }
      });

      if (childTree?.length > 0) {
        item.children = childTree;
        rearrange(childTree);
      }
    })
};
// function formCheck(rowData){
//   return rowData.incorrectCol ? 'text-b-rt' : ''
// }

function getMngData(mngData){
  state.salesOptyParams[state.clickKey.key] = mngData.mngr_nm
}

function moveToPage(url,msg,params){
  if(msg){
    if(!confirm(msg)) return
  }
  
  if(params){
      router.push({
          path : path,
          state : params
      })

  }else{
      router.push(url)
  }
}
</script>
    

<style scoped>
.class-nm{
  display:inline-block;
  height: 20px; 
  width:100px;
  cursor: pointer;
}
.cmp-nm{
  display:inline-block;
  height: 20px; 
  width:200px;
  cursor: pointer;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.custom-sort-icon {
    float: right;
    margin-left: 5px; /* 텍스트와의 간격 조절 */
}
</style>